import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "top-toolbar" }
const _hoisted_2 = { class: "main-controls" }
const _hoisted_3 = { class: "controls-group" }
const _hoisted_4 = { class: "control-item" }
const _hoisted_5 = {
  key: 0,
  class: "data-table-container"
}
const _hoisted_6 = { class: "data-table" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "merged-cell text-center caregiver-info" }
const _hoisted_9 = { class: "merged-cell" }
const _hoisted_10 = { class: "total-cell text-right pr-2" }
const _hoisted_11 = { class: "total-cell" }
const _hoisted_12 = { class: "total-cell text-right pr-2" }
const _hoisted_13 = { class: "total-cell text-right pr-2" }
const _hoisted_14 = { class: "total-cell text-right pr-2" }
const _hoisted_15 = {
  key: 0,
  class: "pa-0",
  style: {"background-color":"#fff"}
}
const _hoisted_16 = { colspan: "7" }
const _hoisted_17 = { class: "payroll-details-compact" }
const _hoisted_18 = {
  key: 0,
  class: "settings-container"
}
const _hoisted_19 = { class: "settings-grid-compact" }
const _hoisted_20 = { class: "settings-card-compact" }
const _hoisted_21 = { class: "compact-form" }
const _hoisted_22 = { class: "compact-field" }
const _hoisted_23 = { class: "input-with-suffix" }
const _hoisted_24 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_25 = { class: "compact-field" }
const _hoisted_26 = { class: "input-with-suffix" }
const _hoisted_27 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_28 = { class: "compact-field" }
const _hoisted_29 = { class: "input-with-suffix" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "compact-field" }
const _hoisted_32 = { class: "allowance-hours-wrapper" }
const _hoisted_33 = { class: "input-with-suffix" }
const _hoisted_34 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_35 = { class: "allowance-amount-text" }
const _hoisted_36 = { class: "compact-field" }
const _hoisted_37 = { class: "allowance-hours-wrapper" }
const _hoisted_38 = { class: "input-with-suffix" }
const _hoisted_39 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_40 = { class: "allowance-amount-text" }
const _hoisted_41 = { class: "compact-field" }
const _hoisted_42 = { class: "allowance-hours-wrapper" }
const _hoisted_43 = { class: "input-with-suffix" }
const _hoisted_44 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_45 = { class: "allowance-amount-text" }
const _hoisted_46 = { class: "compact-field" }
const _hoisted_47 = { class: "input-with-suffix" }
const _hoisted_48 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_49 = { class: "compact-field" }
const _hoisted_50 = { class: "input-with-suffix" }
const _hoisted_51 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_52 = { class: "compact-field welfare-pay-field" }
const _hoisted_53 = { class: "welfare-support-deduct-label" }
const _hoisted_54 = ["onUpdate:modelValue", "disabled"]
const _hoisted_55 = { class: "welfare-pay-input-row" }
const _hoisted_56 = { class: "input-with-suffix" }
const _hoisted_57 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_58 = { class: "compact-field" }
const _hoisted_59 = { class: "input-with-suffix" }
const _hoisted_60 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_61 = { class: "compact-field" }
const _hoisted_62 = { class: "input-with-suffix" }
const _hoisted_63 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_64 = { class: "compact-field" }
const _hoisted_65 = { class: "input-with-suffix" }
const _hoisted_66 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_67 = { class: "compact-field" }
const _hoisted_68 = { class: "input-with-suffix" }
const _hoisted_69 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_70 = { class: "compact-field" }
const _hoisted_71 = { class: "input-with-suffix" }
const _hoisted_72 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_73 = { class: "compact-field" }
const _hoisted_74 = { class: "input-with-suffix" }
const _hoisted_75 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_76 = { class: "compact-field" }
const _hoisted_77 = { class: "input-with-suffix" }
const _hoisted_78 = ["onUpdate:modelValue", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_79 = { class: "compact-field" }
const _hoisted_80 = { class: "input-with-suffix" }
const _hoisted_81 = ["value"]
const _hoisted_82 = { class: "settings-card-compact" }
const _hoisted_83 = { class: "compact-form" }
const _hoisted_84 = { class: "deduction-section" }
const _hoisted_85 = { class: "deduction-section-title" }
const _hoisted_86 = { class: "age-info-badge" }
const _hoisted_87 = ["title"]
const _hoisted_88 = { class: "compact-label" }
const _hoisted_89 = { class: "deduction-toggle-control" }
const _hoisted_90 = { class: "input-with-suffix" }
const _hoisted_91 = ["value", "disabled", "onFocus", "onBlur", "onInput"]
const _hoisted_92 = {
  key: 1,
  value: "0",
  type: "text",
  class: "compact-input",
  readonly: "",
  placeholder: "0"
}
const _hoisted_93 = ["title"]
const _hoisted_94 = { class: "input-with-suffix" }
const _hoisted_95 = ["value"]
const _hoisted_96 = ["title"]
const _hoisted_97 = { class: "input-with-suffix" }
const _hoisted_98 = ["value"]
const _hoisted_99 = ["title"]
const _hoisted_100 = { class: "compact-label" }
const _hoisted_101 = { class: "deduction-toggle-control" }
const _hoisted_102 = {
  key: 0,
  class: "age-info-badge"
}
const _hoisted_103 = { class: "input-with-suffix" }
const _hoisted_104 = ["value"]
const _hoisted_105 = ["title"]
const _hoisted_106 = { class: "input-with-suffix" }
const _hoisted_107 = ["value"]
const _hoisted_108 = ["title"]
const _hoisted_109 = { class: "input-with-suffix" }
const _hoisted_110 = ["value"]
const _hoisted_111 = ["title"]
const _hoisted_112 = { class: "compact-label" }
const _hoisted_113 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_114 = { class: "input-with-suffix" }
const _hoisted_115 = ["value"]
const _hoisted_116 = ["onUpdate:modelValue", "disabled", "onInput", "onBlur", "onFocus"]
const _hoisted_117 = ["title"]
const _hoisted_118 = { class: "compact-label" }
const _hoisted_119 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_120 = {
  key: 0,
  class: "input-with-suffix"
}
const _hoisted_121 = ["value", "onInput", "onBlur", "onFocus", "disabled"]
const _hoisted_122 = ["title"]
const _hoisted_123 = { class: "input-with-suffix" }
const _hoisted_124 = ["value"]
const _hoisted_125 = { class: "deduction-section" }
const _hoisted_126 = { class: "deduction-section-title" }
const _hoisted_127 = { class: "age-info-badge" }
const _hoisted_128 = ["title"]
const _hoisted_129 = { class: "input-with-suffix" }
const _hoisted_130 = ["value"]
const _hoisted_131 = ["title"]
const _hoisted_132 = { class: "input-with-suffix" }
const _hoisted_133 = ["value"]
const _hoisted_134 = ["title"]
const _hoisted_135 = { class: "input-with-suffix" }
const _hoisted_136 = ["value"]
const _hoisted_137 = ["title"]
const _hoisted_138 = { class: "input-with-suffix" }
const _hoisted_139 = ["value"]
const _hoisted_140 = ["title"]
const _hoisted_141 = { class: "input-with-suffix" }
const _hoisted_142 = ["value"]
const _hoisted_143 = ["title"]
const _hoisted_144 = { class: "input-with-suffix" }
const _hoisted_145 = ["value"]
const _hoisted_146 = ["title"]
const _hoisted_147 = { class: "input-with-suffix" }
const _hoisted_148 = ["value"]
const _hoisted_149 = ["title"]
const _hoisted_150 = { class: "input-with-suffix" }
const _hoisted_151 = ["value"]
const _hoisted_152 = { class: "compact-field net-pay-field" }
const _hoisted_153 = { class: "input-with-suffix" }
const _hoisted_154 = ["value"]
const _hoisted_155 = { class: "settings-actions" }
const _hoisted_156 = {
  key: 0,
  class: "settings-container"
}
const _hoisted_157 = { class: "settings-grid-compact" }
const _hoisted_158 = { class: "settings-card-compact" }
const _hoisted_159 = { class: "compact-form" }
const _hoisted_160 = { class: "compact-field" }
const _hoisted_161 = ["value"]
const _hoisted_162 = { class: "compact-field" }
const _hoisted_163 = ["onUpdate:modelValue", "disabled"]
const _hoisted_164 = { class: "compact-field" }
const _hoisted_165 = { class: "jumin-group-compact" }
const _hoisted_166 = ["onUpdate:modelValue", "disabled", "onInput"]
const _hoisted_167 = ["onUpdate:modelValue", "disabled", "onInput"]
const _hoisted_168 = {
  key: 0,
  class: "age-badge-compact"
}
const _hoisted_169 = { class: "compact-field" }
const _hoisted_170 = ["onUpdate:modelValue", "disabled"]
const _hoisted_171 = { class: "compact-field" }
const _hoisted_172 = ["onUpdate:modelValue", "disabled"]
const _hoisted_173 = { class: "compact-field" }
const _hoisted_174 = ["onUpdate:modelValue", "disabled"]
const _hoisted_175 = {
  key: 0,
  class: "compact-field"
}
const _hoisted_176 = { class: "boss-checkbox-simple" }
const _hoisted_177 = ["id", "onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_178 = ["for"]
const _hoisted_179 = { class: "settings-card-compact" }
const _hoisted_180 = { class: "compact-form" }
const _hoisted_181 = { class: "compact-field" }
const _hoisted_182 = ["onUpdate:modelValue", "disabled", "onInput"]
const _hoisted_183 = { class: "compact-field" }
const _hoisted_184 = ["onUpdate:modelValue", "disabled"]
const _hoisted_185 = { class: "compact-field" }
const _hoisted_186 = { style: {"display":"flex","gap":"8px"} }
const _hoisted_187 = ["onUpdate:modelValue", "onClick", "disabled"]
const _hoisted_188 = ["onClick", "disabled"]
const _hoisted_189 = { class: "compact-field" }
const _hoisted_190 = ["onUpdate:modelValue", "disabled"]
const _hoisted_191 = { class: "settings-actions" }
const _hoisted_192 = {
  key: 1,
  class: "empty-data-message text-center pa-4"
}

import EmployeeFormModal from "@/components/employee/EmployeeFormModal.vue";
import store from "@/store";
import { ref, watch, nextTick, computed } from "vue";
import axios from "axios";
import { shouldShowAdminDeductionTooltip } from "./process/payrollTooltipUtils";
import { buildSabokDeductionTooltip, buildSabokCenterTooltip } from "./sabokPayrollTooltipUtils";

// Props 정의
interface Props {
  isMagam?: boolean;
}

interface StaffData {
  empCode?: string;
  name: string;
  type: string;
  timePay: number;
  workHours: number;
  salary: number;
  allowance: number;
  totalSalary: number;
  workStartDate: string;
  workEndDate: string;
  birth?: string;
  phone?: string;
  email?: string;
  address?: string;
  addressDetail?: string;
  isBoss?: boolean;
}

// 사원 데이터
const ALLOWANCE_RATE = 1.5;
const nightAllowanceRate = 0.5;


export default /*@__PURE__*/_defineComponent({
  __name: 'TabSabokWage',
  props: {
    isMagam: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const showAdminDeductionTooltip = computed(() =>
  shouldShowAdminDeductionTooltip(store.getters.isAdmin, store.getters.isImpersonating)
);

const sabokDeductionTooltip = (index: number, field: string): string => {
  if (!showAdminDeductionTooltip.value) return '';
  const settings = staffSettings.value[index];
  if (!settings) return '';
  return buildSabokDeductionTooltip(field, settings, taxData.value);
};

const sabokCenterTooltip = (index: number, field: string): string => {
  if (!showAdminDeductionTooltip.value) return '';
  const settings = staffSettings.value[index];
  if (!settings) return '';
  return buildSabokCenterTooltip(field, settings, taxData.value);
};

// 현재 년월 가져오기 (YYYYMM 형식)
const getCurrentYearMonth = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${year}${month}`;
};

const searchParams = ref({
  sisulCode: store.state.user?.m_sisul_code, // 초기값은 빈 문자열
  lebYm: store.state.lebYm || getCurrentYearMonth(), // 스토어에 저장된 날짜 또는 현재 년월
});

const rules = {
  required: (value: string) => !!value || "필수 입력 항목입니다.",
  yyyymm: (value: string) => /^\d{6}$/.test(value) || "YYYYMM 형식으로 입력해주세요.",  
};

const filterParams = ref({
  caregiverName: "",
  patientName: "",
});

// 펼쳐진 행들을 추적하는 반응형 데이터
const expandedRows = ref(new Set<number>());

// 새로 추가된 행들을 추적하는 반응형 데이터 (애니메이션용)
const newRows = ref(new Set<number>());

// 탭 관리
const activeTab = ref({}) as any;

// 행이 펼쳐져 있는지 확인하는 함수
const isRowExpanded = (index: number) => {
  return expandedRows.value.has(index);
};

// 금액 포맷팅 함수
const formatMoney = (amount: number) => {
  if (!amount) return "0";
  return new Intl.NumberFormat("ko-KR").format(amount);
};

// 사원 데이터 타입 정의
const staffData = ref<StaffData[]>([]);

// 직원 설정 데이터
const staffSettings = ref({}) as any;

// 직원 정보 데이터
const staffInfo = ref({}) as any;

const allowanceHourConfig = {
  overtime: { hoursKey: 'overtimeHours', amountKey: 'overtimeAllowance' },
  night: { hoursKey: 'nightHours', amountKey: 'nightAllowance' },
  holiday: { hoursKey: 'holidayHours', amountKey: 'holidayAllowance' }
} as const;

const getNumericTimePay = (index: number) => {
  const timePayValue = staffSettings.value[index]?.timePay;
  if (!timePayValue) return 0;
  return typeof timePayValue === 'number'
    ? timePayValue
    : parseInt(String(timePayValue).replace(/,/g, ''), 10) || 0;
};

const convertAmountToHours = (amount: number, timePay: number, type: string) => {
  if (!amount || !timePay) return '';
  let rate = 0;
  if (type === 'night') {
    rate = nightAllowanceRate;
  } else {
    rate = ALLOWANCE_RATE;
  }
  const hours = amount / (timePay * rate);
  if (!isFinite(hours) || hours <= 0) return '';
  return parseFloat(hours.toFixed(2)).toString();
};

const updateAllowanceAmountFromHours = (index: number, type: keyof typeof allowanceHourConfig) => {
  const config = allowanceHourConfig[type];
  const settings = staffSettings.value[index];
  if (!settings) return;

  const rawHours = settings[config.hoursKey];
  const hours = rawHours ? parseFloat(String(rawHours).replace(/[^\d.]/g, '')) : 0;
  const timePay = getNumericTimePay(index);

  if (!hours || !timePay) {
    settings[config.amountKey] = 0;
    return;
  }

  // 야간수당은 0.5, 연장/휴일수당은 1.5
  const rate = type === 'night' ? nightAllowanceRate : ALLOWANCE_RATE;
  settings[config.amountKey] = Math.round(hours * timePay * rate);
};

const updateAllHourlyAllowances = (index: number) => {
  (Object.keys(allowanceHourConfig) as Array<keyof typeof allowanceHourConfig>).forEach((type) => {
    updateAllowanceAmountFromHours(index, type);
  });
};

// 주소 검색 관련
const currentAddressIndex = ref<number | null>(null);

// 세금 데이터
const taxData = ref({}) as any;
const sojiData = ref([]) as any;

// 저장 상태
const saving = ref(false);

// 스낵바
const snackbar = ref({
  show: false,
  message: "",
  color: "success",
});

// 스낵바 표시 함수
const showSnackbar = (message: string, color: string = "success") => {
  snackbar.value = {
    show: true,
    message,
    color,
  };
};

// 세금 정보 조회
const getTax = async () => {
  if (!searchParams.value.lebYm) {
    console.error("년월을 입력해주세요.");
    return;
  }
  try {
    const response = await axios.get(`/api/calc/tax/${searchParams.value.lebYm.slice(0, 4)}`);
    if (response.data.success) {
      taxData.value = response.data.data.taxRate;
      sojiData.value = response.data.data.soji;
    } else {
      console.error(response.data.message || "세액 조회 중 오류가 발생했습니다.");
    }
  } catch (error: any) {
    console.error("세액 조회 오류:", error);
  }
};

// 사원 정보 조회
const fetchStaffData = async () => {
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    if (!sisulCode) {
      console.error('시설코드가 없습니다.');
      return;
    }

    const response = await axios.get(`/api/calc/employee-sabok/${sisulCode}`);
    
    if (response.data.success) {
      const employees = response.data.data;
      const currentYm = searchParams.value.lebYm; // YYYYMM 형식
      
      // 입사일에 따라 필터링
      const filteredEmployees = employees.filter((emp: any) => {
        if (!emp.emp_in_date) return true; // 입사일이 없으면 항상 표시
        
        // emp_in_date가 YYYY-MM-DD 형식이라고 가정
        const empInDate = emp.emp_in_date.replace(/-/g, ''); // YYYYMMDD로 변환
        const empInYm = empInDate.substring(0, 6); // YYYYMM만 추출
        
        // 현재 선택된 년월이 입사년월 이상이면 표시
        return currentYm >= empInYm;
      });
      
      // 근무/급여 정보 조회
      const workInfoResponse = await axios.get(`/api/calc/work-info/${sisulCode}/${currentYm}`);
      const workInfoMap = new Map();
      
      if (workInfoResponse.data.success && workInfoResponse.data.data) {
        workInfoResponse.data.data.forEach((workInfo: any) => {
          workInfoMap.set(workInfo.emp_code, workInfo);
        });
      }
      
      // 데이터 변환 및 저장된 근무/급여 정보 적용
      staffData.value = filteredEmployees.map((emp: any) => {
        const workInfo = workInfoMap.get(emp.emp_code);
        
        // 시급 계산: 기본급과 근무시간으로 역산
        let timePay = 0;
        if (workInfo?.ewi_basic_pay && workInfo?.ewi_suga_hours) {
          timePay = Math.round(workInfo.ewi_basic_pay / workInfo.ewi_suga_hours);
        }
        
        const isBoss = emp.emp_isboss === 'Y';
        
        return {
          empCode: emp.emp_code,
          name: emp.emp_name || '',
          type: emp.emp_job || '',
          timePay: timePay,
          workHours: workInfo?.ewi_suga_hours || 0,
          salary: workInfo?.ewi_basic_pay || 0,
          allowance: (workInfo?.ewi_overtime_pay || 0) + (workInfo?.ewi_night_pay || 0) +
                     (workInfo?.ewi_holiday_pay || 0) + (workInfo?.ewi_annual_pay || 0) + 
                     (workInfo?.ewi_long_service_pay || 0) + (workInfo?.ewi_meal_pay || 0) + 
                     (workInfo?.ewi_transportation_fee || 0) + (workInfo?.ewi_education_fee || 0) +
                     (workInfo?.ewi_bonus || 0) + (workInfo?.ewi_other_pay || 0) +
                     (workInfo?.ewi_vehicle_allowance || 0) + (workInfo?.ewi_child_education_fee || 0) +
                     (workInfo?.ewi_welfare_pay || 0),
          totalSalary: workInfo?.ewi_total_pay || 0,
          workStartDate: emp.emp_in_date || '',
          workEndDate: emp.emp_out_date || '',
          birth: emp.emp_birth || '',
          phone: emp.emp_phone || '',
          email: emp.emp_email || '',
          address: emp.emp_addr || '',
          addressDetail: emp.emp_addr_detail || '',
          isBoss: isBoss
        };
      });
      
    } else {
      console.error('사원 정보 조회 실패:', response.data.message);
    }
  } catch (error: any) {
    console.error('사원 정보 조회 오류:', error);
  }
};

// 년월이 변경되면 스토어에 저장
watch(
  () => searchParams.value.lebYm,
  (newLebYm) => {
    if (newLebYm) {
      store.commit('setLebYm', newLebYm);
    }
  }
);

// 스토어의 lebYm이 변경되면 searchParams.lebYm도 업데이트 (외부에서 쿼리 파라미터로 설정된 경우)
watch(
  () => store.state.lebYm,
  (newLebYm) => {
    if (newLebYm && newLebYm !== searchParams.value.lebYm) {
      searchParams.value.lebYm = newLebYm;
    }
  },
  { immediate: true }
);

// YearMonthSelector 변경 감지
watch(() => searchParams.value.lebYm, async () => {
  await getTax();
  await fetchStaffData();
}, { immediate: true });


// 주민번호를 생년월일로 변환하는 함수
const parseJuminToBirthDate = (juminFront: string, juminBack: string): string | null => {
  if (juminFront.length !== 6 || juminBack.length !== 1) return null;

  const yy = parseInt(juminFront.substring(0, 2));
  const mm = juminFront.substring(2, 4);
  const dd = juminFront.substring(4, 6);
  const genderCode = parseInt(juminBack);

  // 성별 코드로 출생년도 판단
  let year: number;
  if (genderCode === 1 || genderCode === 2) {
    // 1900년대
    year = 1900 + yy;
  } else if (genderCode === 3 || genderCode === 4) {
    // 2000년대
    year = 2000 + yy;
  } else {
    return null;
  }

  return `${year}-${mm}-${dd}`;
};

// 원단위 절삭 함수 (예: 51131 -> 51130)
const truncateToTen = (value: number) => Math.floor(value / 10) * 10;

// 만 나이 계산 함수
const calculateAge = (birthDateStr: string, baseYm: string) => {
  if (!birthDateStr || !baseYm) return 0;

  const birthDate = new Date(birthDateStr);
  const baseYear = parseInt(baseYm.substring(0, 4));
  const baseMonth = parseInt(baseYm.substring(4, 6));

  // 기준일 설정 (해당 월의 마지막 날)
  const baseDate = new Date(baseYear, baseMonth, 0);

  // 만 나이 계산
  let age = baseDate.getFullYear() - birthDate.getFullYear();

  // 생일이 지나지 않았으면 1살 빼기
  if (
    baseDate.getMonth() < birthDate.getMonth() ||
    (baseDate.getMonth() === birthDate.getMonth() && baseDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

// 저장된 급여 정보 불러오기
const loadSavedWorkInfo = async (index: number) => {
  const item = staffData.value[index];
  if (!item.empCode) return null;
  
  try {
    const response = await axios.get(`/api/calc/work-info/${item.empCode}/${searchParams.value.lebYm}/employee`);
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    console.error('저장된 급여 정보 조회 오류:', error);
  }
  return null;
};

// 행이 펼쳐질 때 설정 데이터 초기화
const initializeStaffSettings = async (index: number) => {
  if (!staffSettings.value[index]) {
    const item = staffData.value[index];
    
    // 저장된 시급을 우선 사용하고, 없으면 최저시급을 기본값으로 설정
    const defaultTimePayRaw = item?.timePay || taxData.value?.tr_time_pay || '';
    // 컴마가 포함된 형식으로 변환
    let defaultTimePay = '';
    if (defaultTimePayRaw) {
      const numValue = typeof defaultTimePayRaw === 'number' ? defaultTimePayRaw : parseInt(String(defaultTimePayRaw).replace(/,/g, ''));
      if (!isNaN(numValue) && numValue > 0) {
        defaultTimePay = new Intl.NumberFormat("ko-KR").format(numValue);
      }
    }
    
    // 정보 탭의 주민번호 가져오기
    let juminFront = '';
    let juminBack = '';
    let age = null;
    let birthDate = null;
    
    if (staffInfo.value[index]) {
      juminFront = staffInfo.value[index].juminFront || '';
      juminBack = staffInfo.value[index].juminBack || '';
      age = staffInfo.value[index].age;
      birthDate = staffInfo.value[index].birthDate;
    }
    
    // 나이에 따른 초기 공제 플래그 설정
    let initialNationalPensionDeduct = true;
    let initialEmploymentInsuranceDeduct = true;
    let initialRetirementDeduct = true;
    
    // 대표자인 경우 고용보험, 퇴직금 미공제
    const isBoss = item?.isBoss || staffInfo.value[index]?.isBoss || false;
    if (isBoss) {
      initialEmploymentInsuranceDeduct = false;
      initialRetirementDeduct = false;
    }
    
    if (age !== null && age !== undefined && typeof age === 'number') {
      // 60세 이상: 국민연금 미공제
      if (age >= 60) {
        initialNationalPensionDeduct = false;
      }
      // 65세 이상: 고용보험 미공제
      if (age >= 65) {
        initialEmploymentInsuranceDeduct = false;
      }
    }
    
    // 먼저 기본 구조 생성 (화면 렌더링을 위해)
    staffSettings.value[index] = {
      name: item?.name || '',
      juminFront: juminFront,
      juminBack: juminBack,
      age: age,
      birthDate: birthDate,
      workStartDate: item?.workStartDate || '',
      workEndDate: item?.workEndDate || '',
      type: item?.type || '',
      timePay: defaultTimePay,
      workHours: item?.workHours || '209',
      overtimeAllowance: 0,
      nightAllowance: 0,
      holidayAllowance: 0,
      annualLeaveAllowance: '',
      overtimeHours: '',
      nightHours: '',
      holidayHours: '',
      longServiceAllowance: '',
      transportationFee: '',
      educationFee: '',
      bonus: '',
      otherAllowance: '',
      mealAllowance: '',
      vehicleAllowance: '',
      childEducationFee: '',
      welfarePay: '',  // 처우개선비 (2026년 이후, 사회복지사만)
      welfarePaySupportDeduct: true,  // 처우개선비 지원공제 적용 여부
      supportDeductionAuto: true,  // 지원공제 자동 계산 여부 (체크: 자동, 해제: 수동입력)
      supportDeductionManual: '',  // 지원공제 수동 입력 값
      // 4대보험 데이터 구조
      insurance: {
        nationalPension: { 
          amount: 0, 
          deduct: initialNationalPensionDeduct,
          manual: false  // 수동 설정 여부
        },
        healthInsurance: { amount: 0 },
        longTermCare: { amount: 0 },
        employmentInsurance: { 
          amount: 0, 
          deduct: initialEmploymentInsuranceDeduct 
        },
        industrialAccident: { amount: 0, deduct: !isBoss },
        unemployment: { amount: 0, deduct: !isBoss },
        supportDeduction: { amount: 0 },
        retirement: { amount: 0, deduct: initialRetirementDeduct },
        empEtc: { amount: 0, apply: false }
      },
      // 세금 데이터 구조
      tax: {
        incomeTax: 0,
        localTax: 0,
        total: 0
      },
      // 총계 데이터 구조
      totals: {
        taxableAmount: 0,
        nonTaxableAmount: 0,
        employeeTaxSavings: 0,
        centerTaxSavings: 0,
        taxSavings: 0,
        totalDeduction: 0,
        netPay: 0
      }
    };
    
    // 저장된 근무/급여 정보 불러오기 (비동기)
    const savedWorkInfo = await loadSavedWorkInfo(index);
    
    // 저장된 데이터가 있으면 업데이트
    if (savedWorkInfo) {
      staffSettings.value[index].workHours = savedWorkInfo.ewi_suga_hours.toString();
      staffSettings.value[index].overtimeAllowance = savedWorkInfo.ewi_overtime_pay || 0;
      staffSettings.value[index].nightAllowance = savedWorkInfo.ewi_night_pay || 0;
      staffSettings.value[index].holidayAllowance = savedWorkInfo.ewi_holiday_pay || 0;
      staffSettings.value[index].annualLeaveAllowance = savedWorkInfo.ewi_annual_pay
        ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_annual_pay)
        : '';
      staffSettings.value[index].overtimeHours = convertAmountToHours(
        staffSettings.value[index].overtimeAllowance,
        getNumericTimePay(index),
        'overtime'
      );
      staffSettings.value[index].nightHours = convertAmountToHours(
        staffSettings.value[index].nightAllowance,
        getNumericTimePay(index),
        'night'
      );
      staffSettings.value[index].holidayHours = convertAmountToHours(
        staffSettings.value[index].holidayAllowance,
        getNumericTimePay(index),
        'holiday'
      );
      staffSettings.value[index].longServiceAllowance = savedWorkInfo.ewi_long_service_pay ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_long_service_pay) : '';
      staffSettings.value[index].otherAllowance = savedWorkInfo.ewi_other_pay ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_other_pay) : '';
      staffSettings.value[index].transportationFee = savedWorkInfo.ewi_transportation_fee ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_transportation_fee) : '';
      staffSettings.value[index].educationFee = savedWorkInfo.ewi_education_fee ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_education_fee) : '';
      staffSettings.value[index].bonus = savedWorkInfo.ewi_bonus ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_bonus) : '';
      staffSettings.value[index].vehicleAllowance = savedWorkInfo.ewi_vehicle_allowance ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_vehicle_allowance) : '';
      staffSettings.value[index].childEducationFee = savedWorkInfo.ewi_child_education_fee ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_child_education_fee) : '';
      staffSettings.value[index].mealAllowance = savedWorkInfo.ewi_meal_pay ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_meal_pay) : '';
      staffSettings.value[index].welfarePay = savedWorkInfo.ewi_welfare_pay ? new Intl.NumberFormat("ko-KR").format(savedWorkInfo.ewi_welfare_pay) : '';
      staffSettings.value[index].welfarePaySupportDeduct = savedWorkInfo.ewi_welfare_pay_support_deduct !== 'N';  // 기본값 Y
      
      // 국민연금: 저장된 값 반영 및 수동 설정 플래그 설정
      staffSettings.value[index].insurance.nationalPension.amount = savedWorkInfo.ewi_emp_yeon || 0;
      if (savedWorkInfo.ewi_emp_yeon === 0 || !savedWorkInfo.ewi_emp_yeon) {
        staffSettings.value[index].insurance.nationalPension.deduct = false;
        staffSettings.value[index].insurance.nationalPension.manual = false;
      } else {
        // 저장된 값이 있으면 수동 설정으로 간주
        staffSettings.value[index].insurance.nationalPension.deduct = true;
        staffSettings.value[index].insurance.nationalPension.manual = true;
      }
      
      staffSettings.value[index].insurance.healthInsurance.amount = savedWorkInfo.ewi_emp_gun || 0;
      staffSettings.value[index].insurance.longTermCare.amount = savedWorkInfo.ewi_emp_jang || 0;
      
      // 고용보험: 저장된 값이 0원이면 미공제로 설정
      staffSettings.value[index].insurance.employmentInsurance.amount = savedWorkInfo.ewi_emp_go || 0;
      if (savedWorkInfo.ewi_emp_go === 0 || !savedWorkInfo.ewi_emp_go) {
        staffSettings.value[index].insurance.employmentInsurance.deduct = false;
      }
      
      // 산재보험: 저장된 값이 0원이면 미공제로 설정
      staffSettings.value[index].insurance.industrialAccident.amount = savedWorkInfo.ewi_center_san || 0;
      if (savedWorkInfo.ewi_center_san === 0 || !savedWorkInfo.ewi_center_san) {
        staffSettings.value[index].insurance.industrialAccident.deduct = false;
      }
      
      // 실업급여: 저장된 값이 0원이면 미공제로 설정
      staffSettings.value[index].insurance.unemployment.amount = savedWorkInfo.ewi_center_sil || 0;
      if (savedWorkInfo.ewi_center_sil === 0 || !savedWorkInfo.ewi_center_sil) {
        staffSettings.value[index].insurance.unemployment.deduct = false;
      }
      
      staffSettings.value[index].insurance.supportDeduction.amount = savedWorkInfo.ewi_emp_support_deduction || 0;
      
      // 지원공제 자동/수동 설정 불러오기
      if (savedWorkInfo.ewi_support_deduction_auto !== undefined && savedWorkInfo.ewi_support_deduction_auto !== null) {
        staffSettings.value[index].supportDeductionAuto = savedWorkInfo.ewi_support_deduction_auto === 'Y' || savedWorkInfo.ewi_support_deduction_auto === true;
      }
      // 수동 입력값이 있으면 불러오기
      if (!staffSettings.value[index].supportDeductionAuto && savedWorkInfo.ewi_emp_support_deduction > 0) {
        staffSettings.value[index].supportDeductionManual = new Intl.NumberFormat('ko-KR').format(savedWorkInfo.ewi_emp_support_deduction);
      }
      
      // 퇴직금: 저장된 값이 0원이거나 대표자인 경우 미공제로 설정
      staffSettings.value[index].insurance.retirement.amount = savedWorkInfo.ewi_center_out || 0;
      const isBossForRetirement = staffData.value[index]?.isBoss || staffInfo.value[index]?.isBoss || false;
      if (savedWorkInfo.ewi_center_out === 0 || !savedWorkInfo.ewi_center_out || isBossForRetirement) {
        staffSettings.value[index].insurance.retirement.deduct = false;
      }
      
      // 대표자인 경우 고용보험, 산재보험, 실업급여도 미공제로 강제 설정
      if (isBossForRetirement) {
        staffSettings.value[index].insurance.employmentInsurance.deduct = false;
        staffSettings.value[index].insurance.industrialAccident.deduct = false;
        staffSettings.value[index].insurance.unemployment.deduct = false;
      }
      
      // 기타공제 불러오기
      if (savedWorkInfo.ewi_emp_etc && savedWorkInfo.ewi_emp_etc > 0) {
        staffSettings.value[index].insurance.empEtc.amount = savedWorkInfo.ewi_emp_etc;
        staffSettings.value[index].insurance.empEtc.apply = true;
      }
      
      staffSettings.value[index].tax.incomeTax = savedWorkInfo.ewi_emp_so || 0;
      staffSettings.value[index].tax.localTax = savedWorkInfo.ewi_emp_ji || 0;
      staffSettings.value[index].tax.total = (savedWorkInfo.ewi_emp_so || 0) + (savedWorkInfo.ewi_emp_ji || 0);
      
      staffSettings.value[index].totals.taxableAmount = savedWorkInfo.ewi_taxable_amount || 0;
      staffSettings.value[index].totals.nonTaxableAmount = savedWorkInfo.ewi_non_taxable_amount || 0;
      staffSettings.value[index].totals.totalDeduction = savedWorkInfo.ewi_emp_total_deduction || 0;
      staffSettings.value[index].totals.netPay = savedWorkInfo.ewi_net_pay || 0;
    }

    updateAllHourlyAllowances(index);
  }
};

// 행이 펼쳐질 때 정보 데이터 초기화
const initializeStaffInfo = (index: number) => {
  if (!staffInfo.value[index]) {
    const item = staffData.value[index];
    
    // 주민번호 복원 (생년월일에서)
    let juminFront = '';
    let juminBack = '';
    if (item?.birth && item.birth.length === 8) {
      // YYYYMMDD 형식
      const year = item.birth.substring(0, 4);
      const yy = year.substring(2, 4);
      const mm = item.birth.substring(4, 6);
      const dd = item.birth.substring(6, 8);
      juminFront = `${yy}${mm}${dd}`;
      
      // 1900년대면 1 또는 2, 2000년대면 3 또는 4
      const yearNum = parseInt(year);
      juminBack = yearNum >= 2000 ? '3' : '1'; // 성별 구분은 없으므로 남자로 가정
    }
    
    staffInfo.value[index] = {
      staffCode: item?.empCode || '',
      name: item?.name || '',
      juminFront: juminFront,
      juminBack: juminBack,
      age: null,
      birthDate: null,
      type: item?.type || '',
      workStartDate: item?.workStartDate || '',
      workEndDate: item?.workEndDate || '',
      phone: item?.phone || '',
      email: item?.email || '',
      address: item?.address || '',
      addressDetail: item?.addressDetail || '',
      isBoss: item?.isBoss || false
    };
    
    // 나이 계산
    if (juminFront && juminBack) {
      const birthDate = parseJuminToBirthDate(juminFront, juminBack);
      if (birthDate) {
        const age = calculateAge(birthDate, searchParams.value.lebYm);
        staffInfo.value[index].age = age;
        staffInfo.value[index].birthDate = birthDate;
      }
    }
  }
};

// 사원코드 자동 생성
// 형식: 시설코드 앞 2문자 + 직종코드(센터장=1, 사회복지사=2) + 등록일(yymmdd) + 순번(001++)
const generateStaffCode = (index: number) => {
  if (!staffInfo.value[index]) {
    initializeStaffInfo(index);
  }
  
  // 시설코드 앞 2문자
  const sisulCode = store.state.user?.m_sisul_code || '';
  const sisulPrefix = sisulCode.substring(0, 2).toUpperCase() || 'ST';
  
  // 직종코드 (센터장=1, 사회복지사=2)
  const type = staffInfo.value[index]?.type || '';
  let typeCode = '';
  if (type === '센터장') {
    typeCode = '1';
  } else if (type === '사회복지사') {
    typeCode = '2';
  } else {
    // 직종이 선택되지 않았으면 임시로 0
    typeCode = '0';
  }
  
  // yymmdd (등록일 = 현재 날짜)
  const now = new Date();
  const yy = String(now.getFullYear()).substring(2, 4);
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const dateStr = `${yy}${mm}${dd}`;
  
  // 순번 (001++)
  const staffIndex = index + 1;
  const sequence = String(staffIndex).padStart(3, '0');
  
  // 사원코드 조합
  const code = `${sisulPrefix}${typeCode}${dateStr}${sequence}`;
  
  return code;
};

// 대표자 저장 중 플래그
const isSavingBoss = ref(false);

// 대표자 체크박스 변경 처리 (완전히 재작성)
const onBossChange = async (index: number) => {
  // 이미 저장 중이면 무시 (중복 클릭 방지)
  if (isSavingBoss.value) {
    return;
  }
  
  const isBoss = staffInfo.value[index]?.isBoss;
  const sisulCode = store.state.user?.m_sisul_code;
  const currentItem = staffData.value[index];
  
  if (!sisulCode || !currentItem?.empCode) {
    showSnackbar('시설코드 또는 사원 정보가 없습니다.', 'error');
    // 상태 되돌리기
    if (staffInfo.value[index]) {
      staffInfo.value[index].isBoss = !isBoss;
    }
    return;
  }
  
  isSavingBoss.value = true;
  
  try {
    if (isBoss) {
      // === 대표자로 설정 ===
      
      // 1. 현재 직원을 대표자로 DB 저장
      await axios.post('/api/calc/employee', {
        emp_code: currentItem.empCode,
        m_sisul_code: sisulCode,
        emp_name: currentItem.name,
        emp_birth: currentItem.birth,
        emp_job: currentItem.type,
        emp_in_date: currentItem.workStartDate,
        emp_out_date: currentItem.workEndDate,
        emp_phone: currentItem.phone,
        emp_email: currentItem.email,
        emp_addr: currentItem.address,
        emp_addr_detail: currentItem.addressDetail,
        emp_isboss: 'Y'
      });
      
      // 2. 로컬 상태 업데이트 (staffData)
      staffData.value[index].isBoss = true;
      
      // 3. 다른 모든 직원의 대표자 해제 (UI 즉시 반영)
      for (let idx = 0; idx < staffData.value.length; idx++) {
        if (idx !== index) {
          staffData.value[idx].isBoss = false;
          if (staffInfo.value[idx]) {
            staffInfo.value[idx].isBoss = false;
          }
        }
      }
      
      // 4. 다른 직원들 DB 업데이트 (백그라운드)
      const otherUpdatePromises = staffData.value
        .filter((item, idx) => idx !== index && item.empCode)
        .map(item => 
          axios.post('/api/calc/employee', {
            emp_code: item.empCode,
            m_sisul_code: sisulCode,
            emp_name: item.name,
            emp_birth: item.birth,
            emp_job: item.type,
            emp_in_date: item.workStartDate,
            emp_out_date: item.workEndDate,
            emp_phone: item.phone,
            emp_email: item.email,
            emp_addr: item.address,
            emp_addr_detail: item.addressDetail,
            emp_isboss: 'N'
          }).catch(err => console.error('다른 직원 대표자 해제 오류:', err))
        );
      
      // 백그라운드로 업데이트
      Promise.all(otherUpdatePromises);
      
      // 5. 대표자 보험 공제 조정
      if (staffSettings.value[index]) {
        staffSettings.value[index].insurance.employmentInsurance.deduct = false;
        staffSettings.value[index].insurance.industrialAccident.deduct = false;
        staffSettings.value[index].insurance.unemployment.deduct = false;
        staffSettings.value[index].insurance.retirement.deduct = false;
        calculateTaxes(index);
      }
      
      showSnackbar('대표자로 설정되었습니다.', 'success');
      
    } else {
      // === 대표자 해제 ===
      
      // 1. DB 저장
      await axios.post('/api/calc/employee', {
        emp_code: currentItem.empCode,
        m_sisul_code: sisulCode,
        emp_name: currentItem.name,
        emp_birth: currentItem.birth,
        emp_job: currentItem.type,
        emp_in_date: currentItem.workStartDate,
        emp_out_date: currentItem.workEndDate,
        emp_phone: currentItem.phone,
        emp_email: currentItem.email,
        emp_addr: currentItem.address,
        emp_addr_detail: currentItem.addressDetail,
        emp_isboss: 'N'
      });
      
      // 2. 로컬 상태 업데이트
      staffData.value[index].isBoss = false;
      
      // 3. 보험 공제 복원
      if (staffSettings.value[index]) {
        const age = staffSettings.value[index].age;
        staffSettings.value[index].insurance.employmentInsurance.deduct = age === null || age < 65;
        staffSettings.value[index].insurance.industrialAccident.deduct = true;
        staffSettings.value[index].insurance.unemployment.deduct = true;
        staffSettings.value[index].insurance.retirement.deduct = true;
        calculateTaxes(index);
      }
      
      showSnackbar('대표자 설정이 해제되었습니다.', 'success');
    }
    
  } catch (error: any) {
    console.error('대표자 저장 오류:', error);
    showSnackbar('대표자 설정 저장에 실패했습니다.', 'error');
    
    // 오류 발생 시 상태 되돌리기
    if (staffInfo.value[index]) {
      staffInfo.value[index].isBoss = !isBoss;
    }
    if (staffData.value[index]) {
      staffData.value[index].isBoss = !isBoss;
    }
  } finally {
    isSavingBoss.value = false;
  }
};

// 정보 탭 주민번호 입력 시 만나이 자동 계산
const onJuminInputInfo = (index: number) => {
  const juminFront = staffInfo.value[index]?.juminFront || '';
  const juminBack = staffInfo.value[index]?.juminBack || '';

  if (juminFront.length === 6 && juminBack.length === 1) {
    const birthDate = parseJuminToBirthDate(juminFront, juminBack);
    if (birthDate) {
      const age = calculateAge(birthDate, searchParams.value.lebYm);
      if (!staffInfo.value[index]) {
        staffInfo.value[index] = {};
      }
      staffInfo.value[index].age = age;
      staffInfo.value[index].birthDate = birthDate;
      
      // 설정 탭에도 주민번호 동기화
      if (staffSettings.value[index]) {
        staffSettings.value[index].juminFront = juminFront;
        staffSettings.value[index].juminBack = juminBack;
        staffSettings.value[index].age = age;
        staffSettings.value[index].birthDate = birthDate;
        
        // 나이에 따른 자동 공제 플래그 설정
        if (age >= 60) {
          staffSettings.value[index].insurance.nationalPension.deduct = false;
        }
        if (age >= 65) {
          staffSettings.value[index].insurance.employmentInsurance.deduct = false;
        }
        
        // 세금 재계산
        calculateTaxes(index);
      }
    }
  } else {
    if (staffInfo.value[index]) {
      staffInfo.value[index].age = null;
      staffInfo.value[index].birthDate = null;
    }
    if (staffSettings.value[index]) {
      staffSettings.value[index].age = null;
      staffSettings.value[index].birthDate = null;
    }
  }
};

// 정보 탭 전화번호 입력 처리
const onPhoneInputInfo = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    const formatted = formatPhone(target.value);
    target.value = formatted;
    if (staffInfo.value[index]) {
      staffInfo.value[index].phone = formatted;
    }
  }
};

// 시급 입력 포커스 처리
const onTimePayFocus = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    const value = target.value;
    // 컴마 제거하여 숫자만 표시
    const numericValue = value.replace(/,/g, '');
    target.value = numericValue;
    if (staffSettings.value[index]) {
      staffSettings.value[index].timePay = numericValue;
    }
    target.select();
  }
};

// 시급 입력 블러 처리
const onTimePayBlur = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  if (target && target.value) {
    const value = target.value.replace(/,/g, '');
    const numValue = parseInt(value);
    if (!isNaN(numValue)) {
      const formattedValue = new Intl.NumberFormat("ko-KR").format(numValue);
      target.value = formattedValue;
      if (staffSettings.value[index]) {
        staffSettings.value[index].timePay = formattedValue;
        updateAllHourlyAllowances(index);
        // 세금 재계산
        calculateTaxes(index);
      }
    }
  } else {
    target.value = '';
    if (staffSettings.value[index]) {
      staffSettings.value[index].timePay = '';
      updateAllHourlyAllowances(index);
    }
  }
};

// 시급 입력 처리
const onTimePayInput = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    // 숫자가 아닌 문자 제거
    let value = target.value.replace(/[^\d]/g, '');
    
    // 최대 9자리까지 제한
    if (value.length > 9) {
      value = value.slice(0, 9);
    }
    
    target.value = value;
    if (staffSettings.value[index]) {
      staffSettings.value[index].timePay = value;
    }
  }
};

// 근무시간 입력 포커스 처리
const onWorkHoursFocus = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    const value = target.value;
    // 컴마 제거하여 숫자만 표시
    const numericValue = value.replace(/,/g, '');
    target.value = numericValue;
    if (staffSettings.value[index]) {
      staffSettings.value[index].workHours = numericValue;
    }
    target.select();
  }
};

// 근무시간 입력 블러 처리
const onWorkHoursBlur = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  if (target && target.value) {
    const value = target.value.replace(/,/g, '');
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      const formattedValue = numValue.toString();
      target.value = formattedValue;
      if (staffSettings.value[index]) {
        staffSettings.value[index].workHours = formattedValue;
        // 세금 재계산
        calculateTaxes(index);
      }
    }
  } else {
    target.value = '';
    if (staffSettings.value[index]) {
      staffSettings.value[index].workHours = '';
    }
  }
};

// 근무시간 입력 처리
const onWorkHoursInput = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    // 숫자와 소수점만 허용
    let value = target.value.replace(/[^\d.]/g, '');
    
    // 소수점이 여러 개인 경우 첫 번째만 허용
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
    
    // 최대 5자리까지 제한 (예: 999.9)
    if (value.length > 5) {
      value = value.slice(0, 5);
    }
    
    target.value = value;
    if (staffSettings.value[index]) {
      const numValue = parseFloat(value);
      staffSettings.value[index].workHours = isNaN(numValue) ? '' : value;
    }
  }
};

// 급여 계산 (시급 × 근무시간)
const calculateSalary = (index: number) => {
  const timePay = staffSettings.value[index]?.timePay;
  const workHours = staffSettings.value[index]?.workHours;
  
  if (!timePay || !workHours) return '0';
  
  const timePayNum = typeof timePay === 'number' ? timePay : parseInt(String(timePay).replace(/,/g, ''));
  const workHoursNum = typeof workHours === 'number' ? workHours : parseFloat(String(workHours));
  
  if (isNaN(timePayNum) || isNaN(workHoursNum)) return '0';
  
  const salary = Math.floor(timePayNum * workHoursNum);
  return new Intl.NumberFormat("ko-KR").format(salary);
};

// 총 급여 계산 (기본급 + 모든 수당)
const calculateTotalSalary = (index: number) => {
  const timePay = staffSettings.value[index]?.timePay;
  const workHours = staffSettings.value[index]?.workHours;
  
  // 기본급 계산 (사회복지사는 주휴수당 없음)
  let baseSalary = 0;
  if (timePay && workHours) {
    const timePayNum = typeof timePay === 'number' ? timePay : parseInt(String(timePay).replace(/,/g, ''));
    const workHoursNum = typeof workHours === 'number' ? workHours : parseFloat(String(workHours));
    if (!isNaN(timePayNum) && !isNaN(workHoursNum)) {
      baseSalary = Math.floor(timePayNum * workHoursNum);
    }
  }
  
  // 모든 수당 항목 합산
  const allowanceFields = [
    'overtimeAllowance',
    'nightAllowance',
    'holidayAllowance',
    'annualLeaveAllowance',
    'longServiceAllowance',
    'transportationFee',
    'educationFee',
    'bonus',
    'otherAllowance',
    'mealAllowance',
    'vehicleAllowance',
    'childEducationFee',
    'welfarePay'
  ];
  
  let totalAllowance = 0;
  allowanceFields.forEach(field => {
    const value = staffSettings.value[index]?.[field];
    if (value) {
      const numValue = typeof value === 'number' ? value : parseInt(String(value).replace(/,/g, ''));
      if (!isNaN(numValue)) {
        totalAllowance += numValue;
      }
    }
  });
  
  const total = baseSalary + totalAllowance;
  return new Intl.NumberFormat("ko-KR").format(total);
};

// 근로자 공제 합계 계산
const calculateEmployeeDeduction = (index: number) => {
  if (!staffSettings.value[index]) return 0;
  
  const settings = staffSettings.value[index];
  const nationalPension = settings.insurance?.nationalPension?.amount || 0;
  const healthInsurance = settings.insurance?.healthInsurance?.amount || 0;
  const longTermCare = settings.insurance?.longTermCare?.amount || 0;
  const employmentInsurance = settings.insurance?.employmentInsurance?.amount || 0;
  const incomeTax = settings.tax?.incomeTax || 0;
  const localTax = settings.tax?.localTax || 0;
  const supportDeduction = getSupportDeductionValue(index);
  const empEtc = settings.insurance?.empEtc?.apply ? (settings.insurance?.empEtc?.amount || 0) : 0;
  
  return nationalPension + healthInsurance + longTermCare + employmentInsurance + incomeTax + localTax + supportDeduction + empEtc;
};

// 지원공제 값 가져오기 (자동/수동에 따라)
const getSupportDeductionValue = (index: number): number => {
  const settings = staffSettings.value[index];
  if (!settings) return 0;
  
  if (settings.supportDeductionAuto) {
    // 자동 계산
    return calculateSupportDeduction(index);
  } else {
    // 수동 입력값 사용
    const manualValue = settings.supportDeductionManual;
    if (!manualValue) return 0;
    return parseInt(String(manualValue).replace(/,/g, '')) || 0;
  }
};

// 기관 공제 합계 계산
const calculateCenterDeduction = (index: number) => {
  if (!staffSettings.value[index]) return 0;
  
  const settings = staffSettings.value[index];
  const nationalPension = settings.insurance?.nationalPension?.amount || 0;
  const healthInsurance = settings.insurance?.healthInsurance?.amount || 0;
  const longTermCare = settings.insurance?.longTermCare?.amount || 0;
  const employmentInsurance = settings.insurance?.employmentInsurance?.amount || 0;
  const unemployment = settings.insurance?.unemployment?.amount || 0;
  const industrialAccident = settings.insurance?.industrialAccident?.amount || 0;
  const retirement = settings.insurance?.retirement?.amount || 0;
  
  return nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
};

// 지원공제 계산 (장기근속수당 + 처우개선비에 대한 기관 공제)
const calculateSupportDeduction = (index: number) => {
  if (!staffSettings.value[index] || !taxData.value || Object.keys(taxData.value).length === 0) {
    return 0;
  }
  
  const settings = staffSettings.value[index];
  
  // 장기근속수당 금액
  const longServiceAllowanceValue = settings.longServiceAllowance;
  let longServiceAllowanceAmount = 0;
  if (longServiceAllowanceValue) {
    longServiceAllowanceAmount = typeof longServiceAllowanceValue === 'number' 
      ? longServiceAllowanceValue 
      : parseInt(String(longServiceAllowanceValue).replace(/,/g, '')) || 0;
  }
  
  // 처우개선비 금액 (2026년 이후, 사회복지사만)
  // 지원공제 체크박스가 체크된 경우에만 지원공제에 포함
  const welfarePayValue = settings.welfarePay;
  let welfarePayAmount = 0;
  if (welfarePayValue && settings.welfarePaySupportDeduct) {
    welfarePayAmount = typeof welfarePayValue === 'number' 
      ? welfarePayValue 
      : parseInt(String(welfarePayValue).replace(/,/g, '')) || 0;
  }
  
  // 지원공제 대상 금액 합계 (장기근속수당 + 처우개선비(지원공제 체크 시))
  const supportBaseAmount = longServiceAllowanceAmount + welfarePayAmount;
  
  if (supportBaseAmount <= 0) {
    return 0;
  }
  
  // 근무시간
  const workHours = typeof settings.workHours === 'number' 
    ? settings.workHours 
    : parseFloat(String(settings.workHours)) || 0;
  
  // 지원공제 대상 금액에 대한 기관 공제 항목들 계산 (원단위 절삭)
  const supportPension = settings.insurance?.nationalPension?.deduct ? truncateToTen(supportBaseAmount * taxData.value.tr_yeon) : 0;
  const supportHealth = truncateToTen(supportBaseAmount * taxData.value.tr_gun);
  const supportLongTermCare = truncateToTen(supportHealth * taxData.value.tr_jang);
  const supportEmployment = settings.insurance?.employmentInsurance?.deduct ? truncateToTen(supportBaseAmount * taxData.value.tr_go) : 0;
  // 대표자인 경우 실업급여, 산재보험 0원
  const supportUnemployment = (settings.insurance?.employmentInsurance?.deduct && settings.insurance?.unemployment?.deduct !== false) 
    ? truncateToTen(supportBaseAmount * taxData.value.tr_sil) : 0;
  const supportIndustrialAccident = settings.insurance?.industrialAccident?.deduct !== false 
    ? truncateToTen(supportBaseAmount * taxData.value.tr_san) : 0;
  
  // 퇴직금: 근무시간 60시간 이상 + 대표자가 아닐 때만 포함
  let supportRetirement = 0;
  if (workHours >= 60 && settings.insurance?.retirement?.deduct !== false) {
    supportRetirement = truncateToTen(supportBaseAmount / 12);
  }
  
  // 지원공제 = 지원공제 대상 금액에 대한 모든 기관 공제 항목 합계
  return supportPension + supportHealth + supportLongTermCare + supportEmployment + 
         supportUnemployment + supportIndustrialAccident + supportRetirement;
};

// 지원공제 computed (반응형)
const supportDeductionDisplay = computed(() => {
  const result: Record<number, number> = {};
  Object.keys(staffSettings.value).forEach((key) => {
    const idx = parseInt(key);
    result[idx] = calculateSupportDeduction(idx);
  });
  return result;
});

// 기타공제 금액 포맷팅
const formatEtcAmount = (value: number | string) => {
  if (!value) return '';
  const numValue = typeof value === 'number' ? value : parseInt(String(value).replace(/,/g, '')) || 0;
  if (numValue === 0) return '';
  return new Intl.NumberFormat('ko-KR').format(numValue);
};

// 기타공제(근로자) 이벤트 핸들러
const onEmpEtcToggle = (index: number) => {
  const settings = staffSettings.value[index];
  if (!settings) return;
  
  if (settings.insurance.empEtc.apply) {
    settings.insurance.empEtc.amount = 0;
  } else {
    settings.insurance.empEtc.amount = 0;
  }
};

const onEmpEtcInput = (event: Event, index: number) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, '');
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  staffSettings.value[index].insurance.empEtc.amount = parseInt(value) || 0;
};

const onEmpEtcFocus = (event: FocusEvent, index: number) => {
  const input = event.target as HTMLInputElement;
  const value = staffSettings.value[index]?.insurance?.empEtc?.amount || 0;
  // 값이 0이면 빈 문자열로 표시
  input.value = value > 0 ? String(value) : '';
};

const onEmpEtcBlur = (event: FocusEvent, index: number) => {
  const input = event.target as HTMLInputElement;
  const value = parseInt(input.value.replace(/[^\d]/g, '')) || 0;
  staffSettings.value[index].insurance.empEtc.amount = value;
  input.value = value > 0 ? new Intl.NumberFormat('ko-KR').format(value) : '';
};

// 지원공제 자동/수동 토글 핸들러
const onSupportDeductionAutoToggle = (index: number) => {
  const settings = staffSettings.value[index];
  if (!settings) return;
  
  if (settings.supportDeductionAuto) {
    // 자동 계산으로 전환 시 수동 입력값 초기화
    settings.supportDeductionManual = '';
  } else {
    // 수동 입력으로 전환 시 현재 자동 계산값을 수동 입력값으로 세팅
    const autoValue = calculateSupportDeduction(index);
    settings.supportDeductionManual = autoValue > 0 ? new Intl.NumberFormat('ko-KR').format(autoValue) : '';
  }
};

// 지원공제 수동 입력 핸들러
const onSupportDeductionManualInput = (event: Event, index: number) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, '');
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  staffSettings.value[index].supportDeductionManual = value;
};

const onSupportDeductionManualFocus = (event: FocusEvent, index: number) => {
  const input = event.target as HTMLInputElement;
  const value = staffSettings.value[index]?.supportDeductionManual || '';
  // 숫자만 표시
  input.value = String(value).replace(/,/g, '');
};

const onSupportDeductionManualBlur = (event: FocusEvent, index: number) => {
  const input = event.target as HTMLInputElement;
  const value = parseInt(input.value.replace(/[^\d]/g, '')) || 0;
  staffSettings.value[index].supportDeductionManual = value > 0 ? new Intl.NumberFormat('ko-KR').format(value) : '';
};

// 수당 입력 포커스 처리
const onAllowanceFocus = (event: Event, index: number, fieldName: string) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    const value = target.value;
    // 컴마 제거하여 숫자만 표시
    const numericValue = value.replace(/,/g, '');
    target.value = numericValue;
    if (staffSettings.value[index]) {
      staffSettings.value[index][fieldName] = numericValue;
    }
    target.select();
  }
};

// 수당 입력 블러 처리
const onAllowanceBlur = (event: Event, index: number, fieldName: string) => {
  const target = event.target as HTMLInputElement;
  if (target && target.value) {
    const value = target.value.replace(/,/g, '');
    const numValue = parseInt(value);
    if (!isNaN(numValue)) {
      const formattedValue = new Intl.NumberFormat("ko-KR").format(numValue);
      target.value = formattedValue;
      if (staffSettings.value[index]) {
        staffSettings.value[index][fieldName] = formattedValue;
        // 세금 재계산
        calculateTaxes(index);
      }
    }
  } else {
    target.value = '';
    if (staffSettings.value[index]) {
      staffSettings.value[index][fieldName] = '';
    }
  }
};

// 수당 입력 처리
const onAllowanceInput = (event: Event, index: number, fieldName: string) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    // 숫자가 아닌 문자 제거
    let value = target.value.replace(/[^\d]/g, '');
    
    // 최대 9자리까지 제한
    if (value.length > 9) {
      value = value.slice(0, 9);
    }
    
    target.value = value;
    if (staffSettings.value[index]) {
      staffSettings.value[index][fieldName] = value;
    }
  }
};

const onAllowanceHoursFocus = (event: Event, _index?: number, _type?: keyof typeof allowanceHourConfig) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    target.select();
  }
};

const onAllowanceHoursInput = (event: Event, index: number, type: keyof typeof allowanceHourConfig) => {
  const target = event.target as HTMLInputElement;
  if (!target) return;

  let value = target.value.replace(/[^\d.]/g, '');
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('');
  }
  if (value.length > 6) {
    value = value.slice(0, 6);
  }
  target.value = value;

  const config = allowanceHourConfig[type];
  if (staffSettings.value[index]) {
    staffSettings.value[index][config.hoursKey] = value;
  }
};

const onAllowanceHoursBlur = (event: Event, index: number, type: keyof typeof allowanceHourConfig) => {
  const target = event.target as HTMLInputElement;
  if (!target) return;

  const config = allowanceHourConfig[type];
  const settings = staffSettings.value[index];
  if (!settings) return;

  const value = target.value.replace(/[^\d.]/g, '');
  if (!value) {
    target.value = '';
    settings[config.hoursKey] = '';
    settings[config.amountKey] = 0;
    calculateTaxes(index);
    return;
  }

  const hours = parseFloat(value);
  if (isNaN(hours)) {
    target.value = '';
    settings[config.hoursKey] = '';
    settings[config.amountKey] = 0;
    calculateTaxes(index);
    return;
  }

  const normalized = hours.toString();
  target.value = normalized;
  settings[config.hoursKey] = normalized;
  updateAllowanceAmountFromHours(index, type);
  calculateTaxes(index);
};

// 소득세 계산 함수
const calculateIncomeTax = (taxableIncome: number) => {
  if (!sojiData.value || sojiData.value.length === 0) {
    return 0;
  }

  // 소득세 데이터에서 해당 구간 찾기
  for (let i = 0; i < sojiData.value.length; i++) {
    const obj = sojiData.value[i];
    const minIncome = obj.income1 * 1000;
    const maxIncome = obj.income2 * 1000;

    if (taxableIncome >= minIncome && taxableIncome < maxIncome) {
      const result = Math.round(obj.depe_1);
      return result;
    }
  }

  return 0;
};

// 국민연금 표시값 computed
const nationalPensionDisplay = computed(() => {
  const result: Record<number, string> = {};
  Object.keys(staffSettings.value).forEach((key) => {
    const idx = parseInt(key);
    const settings = staffSettings.value[idx];
    if (settings?.insurance?.nationalPension) {
      const amount = settings.insurance.nationalPension.amount || 0;
      result[idx] = formatMoney(amount);
    } else {
      result[idx] = '0';
    }
  });
  return result;
});

// 국민연금 수동 입력 이벤트 핸들러
const onNationalPensionInput = (event: Event, index: number) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  value = value.replace(/[^\d]/g, '');
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  input.value = value;
  
  const settings = staffSettings.value[index];
  if (!settings) return;
  
  const numericValue = parseInt(value) || 0;
  settings.insurance.nationalPension.amount = numericValue;
  settings.insurance.nationalPension.manual = true;
};

const onNationalPensionFocus = (event: FocusEvent, index: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue === '0' ? '' : numericValue;
};

const onNationalPensionBlur = (event: FocusEvent, index: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/[^\d]/g, '');
  
  const settings = staffSettings.value[index];
  if (!settings) return;
  
  if (numericValue) {
    const parsedValue = parseInt(numericValue);
    settings.insurance.nationalPension.amount = parsedValue;
    settings.insurance.nationalPension.manual = true;
    input.value = new Intl.NumberFormat('ko-KR').format(parsedValue);
  } else {
    settings.insurance.nationalPension.amount = 0;
    settings.insurance.nationalPension.manual = true;
    input.value = '0';
  }
  
  // 공제 합계 등 재계산 (국민연금 제외)
  recalculateTotals(index);
};

// 국민연금 제외 재계산 (수동 설정 시)
const recalculateTotals = (index: number) => {
  const settings = staffSettings.value[index];
  if (!settings) return;
  
  // 총 공제액 재계산
  settings.totals.totalDeduction = 
    settings.insurance.nationalPension.amount +
    settings.insurance.healthInsurance.amount +
    settings.insurance.longTermCare.amount +
    settings.insurance.employmentInsurance.amount +
    (settings.tax?.incomeTax || 0) +
    (settings.tax?.localTax || 0) +
    calculateSupportDeduction(index) +
    (settings.insurance.empEtc?.apply ? (settings.insurance.empEtc?.amount || 0) : 0);
  
  // 실수령액 재계산
  const timePay = typeof settings.timePay === 'number' ? settings.timePay : parseInt(String(settings.timePay).replace(/,/g, '')) || 0;
  const workHours = typeof settings.workHours === 'number' ? settings.workHours : parseFloat(String(settings.workHours)) || 0;
  const baseSalary = Math.floor(timePay * workHours);
  
  let totalAllowance = 0;
  const allowanceFields = [
    'overtimeAllowance', 'nightAllowance', 'holidayAllowance', 'annualLeaveAllowance',
    'longServiceAllowance', 'transportationFee', 'educationFee', 'bonus',
    'otherAllowance', 'mealAllowance', 'vehicleAllowance', 'childEducationFee', 'welfarePay'
  ];
  
  allowanceFields.forEach(field => {
    const value = settings[field];
    if (value) {
      const numValue = typeof value === 'number' ? value : parseInt(String(value).replace(/,/g, '')) || 0;
      totalAllowance += numValue;
    }
  });
  
  const totalPay = baseSalary + totalAllowance;
  settings.totals.netPay = totalPay - settings.totals.totalDeduction;
};

// 국민연금 공제 설정 함수 (체크박스 토글)
const setNationalPensionDeduction = (index: number, value: boolean) => {
  if (!staffSettings.value[index]) return;
  
  const settings = staffSettings.value[index];
  settings.insurance.nationalPension.deduct = value;
  
  if (value) {
    // 체크 활성화: 자동 계산된 값 설정
    settings.insurance.nationalPension.manual = false;
    // 세금 재계산 (자동 계산 적용)
    calculateTaxes(index);
  } else {
    // 체크 해제: 금액 0으로 설정
    settings.insurance.nationalPension.amount = 0;
    settings.insurance.nationalPension.manual = false;
    // 공제 합계 등 재계산
    recalculateTotals(index);
  }
};

// 고용보험 공제 설정 함수
const setEmploymentInsuranceDeduction = (index: number, value: boolean) => {
  if (!staffSettings.value[index]) return;
  
  staffSettings.value[index].insurance.employmentInsurance.deduct = value;
  
  // 세금 재계산
  calculateTaxes(index);
};

// 세금 계산 함수
const calculateTaxes = (index: number) => {
  if (!staffSettings.value[index] || !taxData.value || Object.keys(taxData.value).length === 0) {
    return;
  }

  const settings = staffSettings.value[index];
  
  // 시급과 근무시간
  const timePay = typeof settings.timePay === 'number' ? settings.timePay : parseInt(String(settings.timePay).replace(/,/g, '')) || 0;
  const workHours = typeof settings.workHours === 'number' ? settings.workHours : parseFloat(String(settings.workHours)) || 0;
  
  if (!timePay || !workHours) return;
  
  // 기본급 계산 (사회복지사는 주휴수당 없음)
  const baseSalary = Math.floor(timePay * workHours);
  
  // 모든 수당 합계
  const allowanceFields = [
    'overtimeAllowance', 'nightAllowance', 'holidayAllowance', 'annualLeaveAllowance',
    'longServiceAllowance', 'transportationFee', 'educationFee', 'bonus',
    'otherAllowance', 'mealAllowance', 'vehicleAllowance', 'childEducationFee', 'welfarePay'
  ];
  
  let totalAllowance = 0;
  let nonTaxableAllowance = 0; // 비과세 수당 (식대, 차량보조비, 자녀교육비)
  
  allowanceFields.forEach(field => {
    const value = settings[field];
    if (value) {
      const numValue = typeof value === 'number' ? value : parseInt(String(value).replace(/,/g, '')) || 0;
      totalAllowance += numValue;
      
      // 비과세 항목 처리 (식대 20만원, 차량보조비 20만원, 자녀교육비)
      if (field === 'mealAllowance') {
        nonTaxableAllowance += Math.min(numValue, 200000); // 식대 최대 20만원 비과세
      } else if (field === 'vehicleAllowance') {
        nonTaxableAllowance += Math.min(numValue, 200000); // 차량보조비 최대 20만원 비과세
      } else if (field === 'childEducationFee') {
        nonTaxableAllowance += numValue; // 자녀교육비 전액 비과세
      }
    }
  });
  
  // 과세 금액 = 기본급 + (총수당 - 비과세수당)
  const taxableAmount = baseSalary + (totalAllowance - nonTaxableAllowance);
  
  // 주민번호에서 나이 계산 (국민연금, 고용보험 면제 판단)
  const juminFront = settings.juminFront || '';
  const juminBack = settings.juminBack || '';
  let caregiverAge = 0;
  
  if (juminFront.length === 6 && juminBack.length === 1) {
    const birthDate = parseJuminToBirthDate(juminFront, juminBack);
    if (birthDate) {
      caregiverAge = calculateAge(birthDate, searchParams.value.lebYm);
    }
  }
  
  // 4대보험 계산 (공제 플래그 고려, 원단위 절삭 적용)
  // 사용자가 수동으로 설정한 플래그를 존중하되, 계산에만 반영
  // 국민연금: 수동 설정된 경우 자동 계산 건너뛰기
  if (!settings.insurance.nationalPension.manual) {
    settings.insurance.nationalPension.amount = settings.insurance.nationalPension.deduct ? truncateToTen(taxableAmount * taxData.value.tr_yeon) : 0;
  }
  settings.insurance.healthInsurance.amount = truncateToTen(taxableAmount * taxData.value.tr_gun);
  settings.insurance.employmentInsurance.amount = settings.insurance.employmentInsurance.deduct ? truncateToTen(taxableAmount * taxData.value.tr_go) : 0;
  // 산재보험, 실업급여: 대표자인 경우 0원 (deduct 플래그 확인, 원단위 절삭)
  settings.insurance.industrialAccident.amount = settings.insurance.industrialAccident?.deduct !== false ? truncateToTen(taxableAmount * taxData.value.tr_san) : 0;
  settings.insurance.unemployment.amount = (settings.insurance.employmentInsurance.deduct && settings.insurance.unemployment?.deduct !== false) ? truncateToTen(taxableAmount * taxData.value.tr_sil) : 0;
  settings.insurance.longTermCare.amount = truncateToTen(settings.insurance.healthInsurance.amount * taxData.value.tr_jang);
  
  // 퇴직금 계산 (근무시간 60시간 미만이면 0원, 대표자인 경우 0원, 원단위 절삭)
  const totalPay = baseSalary + totalAllowance;
  if (workHours >= 60 && settings.insurance.retirement?.deduct !== false) {
    settings.insurance.retirement.amount = truncateToTen(totalPay / 12);
  } else {
    settings.insurance.retirement.amount = 0;
  }
  
  // 지원공제 계산 (자동/수동에 따라)
  settings.insurance.supportDeduction.amount = getSupportDeductionValue(index);
  
  // 소득세, 지방세 계산 (원단위 절삭)
  settings.tax.incomeTax = truncateToTen(calculateIncomeTax(taxableAmount));
  settings.tax.localTax = truncateToTen(settings.tax.incomeTax * 0.1);
  settings.tax.total = settings.tax.incomeTax + settings.tax.localTax;
  
  // 총계 계산
  settings.totals.taxableAmount = taxableAmount;
  settings.totals.nonTaxableAmount = nonTaxableAllowance;
  
  // 총 공제액 (실수령액 계산용)
  settings.totals.totalDeduction = 
    settings.insurance.nationalPension.amount +
    settings.insurance.healthInsurance.amount +
    settings.insurance.longTermCare.amount +
    settings.insurance.employmentInsurance.amount +
    settings.tax.incomeTax +
    settings.tax.localTax +
    settings.insurance.supportDeduction.amount +
    (settings.insurance.empEtc?.apply ? (settings.insurance.empEtc?.amount || 0) : 0);
  
  // 실수령액
  settings.totals.netPay = totalPay - settings.totals.totalDeduction;
  
  // 비과세 절감액 계산 (근로자 + 센터)
  if (nonTaxableAllowance > 0) {
    // 비과세를 과세로 계산했을 경우
    const taxableWithNonTax = taxableAmount + nonTaxableAllowance;
    const incomeTaxWithNonTax = calculateIncomeTax(taxableWithNonTax);
    const localTaxWithNonTax = Math.round(incomeTaxWithNonTax * 0.1);
    
    // 근로자 절감액
    const taxSavings = (incomeTaxWithNonTax + localTaxWithNonTax) - (settings.tax.incomeTax + settings.tax.localTax);
    const pensionSavings = settings.insurance.nationalPension.deduct ? truncateToTen(nonTaxableAllowance * taxData.value.tr_yeon) : 0;
    const healthSavings = truncateToTen(nonTaxableAllowance * taxData.value.tr_gun);
    const longTermCareSavings = truncateToTen(healthSavings * taxData.value.tr_jang);
    const employmentSavings = settings.insurance.employmentInsurance.deduct ? truncateToTen(nonTaxableAllowance * taxData.value.tr_go) : 0;
    
    settings.totals.employeeTaxSavings = Math.max(0, 
      taxSavings + pensionSavings + healthSavings + longTermCareSavings + employmentSavings
    );
    
    // 센터 절감액
    const centerPensionSavings = settings.insurance.nationalPension.deduct ? truncateToTen(nonTaxableAllowance * taxData.value.tr_yeon) : 0;
    const centerHealthSavings = truncateToTen(nonTaxableAllowance * taxData.value.tr_gun);
    const centerLongTermCareSavings = truncateToTen(centerHealthSavings * taxData.value.tr_jang);
    const centerEmploymentSavings = settings.insurance.employmentInsurance.deduct ? truncateToTen(nonTaxableAllowance * taxData.value.tr_go) : 0;
    // 대표자인 경우 실업급여, 산재보험, 퇴직금 절감액 0원
    const unemploymentSavings = (settings.insurance.employmentInsurance.deduct && settings.insurance.unemployment?.deduct !== false) ? truncateToTen(nonTaxableAllowance * taxData.value.tr_sil) : 0;
    const industrialAccidentSavings = settings.insurance.industrialAccident?.deduct !== false ? truncateToTen(nonTaxableAllowance * taxData.value.tr_san) : 0;
    
    // 퇴직금 절감액: 근무시간 60시간 이상 + 대표자가 아닐 때만 포함
    let retirementSavings = 0;
    if (workHours >= 60 && settings.insurance.retirement?.deduct !== false) {
      retirementSavings = truncateToTen(nonTaxableAllowance / 12);
    }
    
    settings.totals.centerTaxSavings = Math.max(0,
      centerPensionSavings + centerHealthSavings + centerLongTermCareSavings + 
      centerEmploymentSavings + unemploymentSavings + industrialAccidentSavings + retirementSavings
    );
    
    settings.totals.taxSavings = settings.totals.employeeTaxSavings + settings.totals.centerTaxSavings;
  } else {
    settings.totals.employeeTaxSavings = 0;
    settings.totals.centerTaxSavings = 0;
    settings.totals.taxSavings = 0;
  }
};

// 전화번호 포맷팅
const formatPhone = (value: string) => {
  const digits = value.replace(/[^\d]/g, '').slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,7)}-${digits.slice(7)}`;
};

// 사업자번호 포맷팅
const formatBizNum = (value: string) => {
  const digits = value.replace(/[^\d]/g, '').slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,5)}-${digits.slice(5)}`;
};

// 전화번호 입력 처리
const onPhoneInput = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    const formatted = formatPhone(target.value);
    target.value = formatted;
    if (staffInfo.value[index]) {
      staffInfo.value[index].m_phone = formatted;
    }
  }
};

// 사업자번호 입력 처리
const onBizNumInput = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  if (target) {
    const formatted = formatBizNum(target.value);
    target.value = formatted;
    if (staffInfo.value[index]) {
      staffInfo.value[index].m_biz_num = formatted;
    }
  }
};

// 다음 주소 API 스크립트 로드
let daumScriptLoading: Promise<void> | null = null;

const loadDaumPostcodeScript = async (): Promise<void> => {
  if ((window as any).daum?.Postcode) return;
  if (daumScriptLoading) {
    await daumScriptLoading;
    return;
  }
  daumScriptLoading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Daum Postcode script load failed'));
    document.head.appendChild(script);
  });
  await daumScriptLoading;
};

// 주소 검색 모달 열기
const openAddressModal = async (index: number) => {
  currentAddressIndex.value = index;
  
  try {
    await loadDaumPostcodeScript();
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode not loaded');
    
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        
        if (currentAddressIndex.value !== null && staffInfo.value[currentAddressIndex.value]) {
          staffInfo.value[currentAddressIndex.value].address = selected || '';
        }
        currentAddressIndex.value = null;
      },
      onclose: () => {
        currentAddressIndex.value = null;
      }
    });
    postcode.open();
  } catch (e) {
    console.error('주소 검색 오류:', e);
    currentAddressIndex.value = null;
  }
};

// 정보 저장 함수
const saveStaffInfo = async (index: number) => {
  if (!staffInfo.value[index]) {
    initializeStaffInfo(index);
  }
  
  const info = staffInfo.value[index];
  
  // 기존 사원코드가 있으면 사용, 없으면 새로 생성
  const existingEmpCode = staffData.value[index]?.empCode;
  const staffCode = existingEmpCode || generateStaffCode(index);
  staffInfo.value[index].staffCode = staffCode;
  
  // 필수 필드 검증
  if (!info.name || !info.type) {
    alert('성명과 직종은 필수 입력 항목입니다.');
    return;
  }
  
  try {
    // 주민번호 앞자리만 저장 (생년월일로 변환)
    let emp_birth = '';
    if (info.juminFront && info.juminBack) {
      const birthDate = parseJuminToBirthDate(info.juminFront, info.juminBack);
      if (birthDate) {
        // YYYY-MM-DD 형식에서 YYYYMMDD로 변환
        emp_birth = birthDate.replace(/-/g, '');
      }
    }
    
    // API 호출 데이터 준비
    const sisulCode = store.state.user?.m_sisul_code;
    if (!sisulCode) {
      alert('시설코드가 없습니다. 다시 로그인해주세요.');
      return;
    }
    
    // isBoss는 staffInfo에서 가져옴 (체크박스 상태)
    const isBoss = info.isBoss || false;
    
    const employeeData = {
      emp_code: staffCode,
      m_sisul_code: sisulCode,
      emp_name: info.name || '',
      emp_birth: emp_birth,
      emp_job: info.type || '',
      emp_in_date: info.workStartDate || '',
      emp_out_date: info.workEndDate || '',
      emp_phone: info.phone || '',
      emp_email: info.email || '',
      emp_addr: info.address || '',
      emp_addr_detail: info.addressDetail || '',
      emp_isboss: isBoss ? 'Y' : 'N'
    };
    
    const response = await axios.post('/api/calc/employee', employeeData);
    
    if (response.data.success) {
      alert('사원 정보가 저장되었습니다.');
      // 저장된 사원코드 업데이트
      staffInfo.value[index].staffCode = staffCode;
      // 사원 목록 다시 조회
      await fetchStaffData();
    } else {
      alert(response.data.message || '저장에 실패했습니다.');
    }
  } catch (error: any) {
    console.error('사원 정보 저장 오류:', error);
    alert(error.response?.data?.message || '저장 중 오류가 발생했습니다.');
  }
};

// 통합 저장 함수 (사원정보 + 급여설정 모두 저장)
const saveStaffAll = async (index: number) => {
  try {
    // 1. 먼저 사원 정보 저장
    await saveStaffInfoInternal(index);
    
    // 2. 급여 설정 저장 (사원코드가 있는 경우에만)
    const item = staffData.value[index];
    if (item?.empCode) {
      await saveStaffSettingsInternal(index);
      showSnackbar('사원 정보와 급여 설정이 저장되었습니다.', 'success');
    } else {
      showSnackbar('사원 정보가 저장되었습니다.', 'success');
    }
    
    // 데이터 새로고침
    await fetchStaffData();
  } catch (error: any) {
    console.error('저장 오류:', error);
    showSnackbar(error.message || '저장 중 오류가 발생했습니다.', 'error');
  }
};

// 사원 정보 저장 내부 함수 (alert 대신 throw 사용)
const saveStaffInfoInternal = async (index: number) => {
  if (!staffInfo.value[index]) {
    initializeStaffInfo(index);
  }
  
  const info = staffInfo.value[index];
  
  // 기존 사원코드가 있으면 사용, 없으면 새로 생성
  const existingEmpCode = staffData.value[index]?.empCode;
  const staffCode = existingEmpCode || generateStaffCode(index);
  staffInfo.value[index].staffCode = staffCode;
  
  // 필수 필드 검증
  if (!info.name || !info.type) {
    throw new Error('성명과 직종은 필수 입력 항목입니다.');
  }
  
  // 주민번호 앞자리만 저장 (생년월일로 변환)
  let emp_birth = '';
  if (info.juminFront && info.juminBack) {
    const birthDate = parseJuminToBirthDate(info.juminFront, info.juminBack);
    if (birthDate) {
      emp_birth = birthDate.replace(/-/g, '');
    }
  }
  
  const sisulCode = store.state.user?.m_sisul_code;
  if (!sisulCode) {
    throw new Error('시설코드가 없습니다. 다시 로그인해주세요.');
  }
  
  const isBoss = info.isBoss || false;
  
  const employeeData = {
    emp_code: staffCode,
    m_sisul_code: sisulCode,
    emp_name: info.name || '',
    emp_birth: emp_birth,
    emp_job: info.type || '',
    emp_in_date: info.workStartDate || '',
    emp_out_date: info.workEndDate || '',
    emp_phone: info.phone || '',
    emp_email: info.email || '',
    emp_addr: info.address || '',
    emp_addr_detail: info.addressDetail || '',
    emp_isboss: isBoss ? 'Y' : 'N'
  };
  
  const response = await axios.post('/api/calc/employee', employeeData);
  
  if (response.data.success) {
    staffInfo.value[index].staffCode = staffCode;
    // staffData도 업데이트
    if (staffData.value[index]) {
      staffData.value[index].empCode = staffCode;
    }
  } else {
    throw new Error(response.data.message || '사원 정보 저장에 실패했습니다.');
  }
};

// 급여 설정 저장 내부 함수 (alert 대신 throw 사용)
const saveStaffSettingsInternal = async (index: number) => {
  if (!staffSettings.value[index]) {
    initializeStaffSettings(index);
  }
  
  const item = staffData.value[index];
  if (!item.empCode) {
    throw new Error('사원코드가 없습니다.');
  }
  
  // 정보 탭에서 저장된 정보 가져오기
  if (staffInfo.value[index]) {
    staffSettings.value[index].name = staffInfo.value[index].name || '';
    staffSettings.value[index].type = staffInfo.value[index].type || '';
    staffSettings.value[index].workStartDate = staffInfo.value[index].workStartDate || '';
    staffSettings.value[index].workEndDate = staffInfo.value[index].workEndDate || '';
  }
  
  const settings = staffSettings.value[index];
  const sisulCode = store.state.user?.m_sisul_code;
  
  if (!sisulCode) {
    throw new Error('시설코드가 없습니다.');
  }
  
  const timePay = typeof settings.timePay === 'number' ? settings.timePay : parseInt(String(settings.timePay).replace(/,/g, '')) || 0;
  const workHours = typeof settings.workHours === 'number' ? settings.workHours : parseFloat(String(settings.workHours)) || 0;
  const basicPay = Math.floor(timePay * workHours);
  
  const parseAllowance = (value: any) => {
    if (!value) return 0;
    return typeof value === 'number' ? value : parseInt(String(value).replace(/,/g, '')) || 0;
  };
  
  const overtimeAllowance = parseAllowance(settings.overtimeAllowance);
  const nightAllowance = parseAllowance(settings.nightAllowance);
  const holidayAllowance = parseAllowance(settings.holidayAllowance);
  const annualLeaveAllowance = parseAllowance(settings.annualLeaveAllowance);
  const longServiceAllowance = parseAllowance(settings.longServiceAllowance);
  const transportationFee = parseAllowance(settings.transportationFee);
  const educationFee = parseAllowance(settings.educationFee);
  const bonus = parseAllowance(settings.bonus);
  const otherAllowance = parseAllowance(settings.otherAllowance);
  const mealAllowance = parseAllowance(settings.mealAllowance);
  const vehicleAllowance = parseAllowance(settings.vehicleAllowance);
  const childEducationFee = parseAllowance(settings.childEducationFee);
  const welfarePay = parseAllowance(settings.welfarePay);
  
  const totalPay = basicPay + overtimeAllowance + nightAllowance + holidayAllowance + annualLeaveAllowance +
                   longServiceAllowance + transportationFee + educationFee + bonus + otherAllowance +
                   mealAllowance + vehicleAllowance + childEducationFee + welfarePay;
  
  const workData = {
    emp_code: item.empCode,
    m_sisul_code: sisulCode,
    ewi_ym: searchParams.value.lebYm,
    ewi_suga_hours: workHours,
    ewi_service_days: 0,
    ewi_total_minutes: Math.round(workHours * 60),
    ewi_lunch_time_count: 0,
    ewi_monthly_pay: 0,
    ewi_basic_pay: basicPay,
    ewi_weekly_pay: 0,
    ewi_annual_pay: annualLeaveAllowance,
    ewi_holiday_pay: holidayAllowance,
    ewi_overtime_pay: overtimeAllowance,
    ewi_night_pay: nightAllowance,
    ewi_labor_day_pay: 0,
    ewi_long_service_pay: longServiceAllowance,
    ewi_severe_care_addition: 0,
    ewi_meal_pay: mealAllowance,
    ewi_other_pay: otherAllowance,
    ewi_transportation_fee: transportationFee,
    ewi_education_fee: educationFee,
    ewi_bonus: bonus,
    ewi_vehicle_allowance: vehicleAllowance,
    ewi_child_education_fee: childEducationFee,
    ewi_welfare_pay: welfarePay,
    ewi_welfare_pay_support_deduct: settings.welfarePaySupportDeduct ? 'Y' : 'N',
    ewi_total_pay: totalPay,
    ewi_emp_yeon: settings.insurance?.nationalPension?.amount || 0,
    ewi_emp_gun: settings.insurance?.healthInsurance?.amount || 0,
    ewi_emp_jang: settings.insurance?.longTermCare?.amount || 0,
    ewi_emp_go: settings.insurance?.employmentInsurance?.amount || 0,
    ewi_emp_so: settings.tax?.incomeTax || 0,
    ewi_emp_ji: settings.tax?.localTax || 0,
    ewi_emp_support_deduction: getSupportDeductionValue(index),
    ewi_support_deduction_auto: settings.supportDeductionAuto ? 'Y' : 'N',
    ewi_emp_etc: settings.insurance?.empEtc?.amount || 0,
    ewi_emp_total_deduction: calculateEmployeeDeduction(index),
    ewi_center_yeon: settings.insurance?.nationalPension?.amount || 0,
    ewi_center_gun: settings.insurance?.healthInsurance?.amount || 0,
    ewi_center_jang: settings.insurance?.longTermCare?.amount || 0,
    ewi_center_go: settings.insurance?.employmentInsurance?.amount || 0,
    ewi_center_sil: settings.insurance?.unemployment?.amount || 0,
    ewi_center_san: settings.insurance?.industrialAccident?.amount || 0,
    ewi_center_out: settings.insurance?.retirement?.amount || 0,
    ewi_center_total_deduction: calculateCenterDeduction(index),
    ewi_net_pay: settings.totals?.netPay || 0,
    ewi_taxable_amount: settings.totals?.taxableAmount || 0,
    ewi_non_taxable_amount: settings.totals?.nonTaxableAmount || 0,
    ewi_emp_tax_savings: settings.totals?.employeeTaxSavings || 0,
    ewi_center_tax_savings: settings.totals?.centerTaxSavings || 0,
    ewi_center_profit: 0  // 사복직원은 수가금액이 없으므로 0
  };
  
  const response = await axios.post('/api/calc/work-info', workData);
  
  if (response.data.success) {
    staffData.value[index].timePay = timePay;
    staffData.value[index].workHours = workHours;
    staffData.value[index].salary = basicPay;
    staffData.value[index].totalSalary = totalPay;
    staffData.value[index].allowance = overtimeAllowance + nightAllowance + holidayAllowance + 
      annualLeaveAllowance + longServiceAllowance + mealAllowance + 
      transportationFee + educationFee + bonus + otherAllowance + vehicleAllowance + childEducationFee + welfarePay;
  } else {
    throw new Error(response.data.message || '급여 설정 저장에 실패했습니다.');
  }
};

// 설정 저장 함수 (기존 함수 유지 - 호환성)
const saveStaffSettings = async (index: number) => {
  if (!staffSettings.value[index]) {
    initializeStaffSettings(index);
  }
  
  const item = staffData.value[index];
  if (!item.empCode) {
    alert('사원코드가 없습니다. 먼저 사원 정보를 저장해주세요.');
    return;
  }
  
  // 정보 탭에서 저장된 정보 가져오기
  if (staffInfo.value[index]) {
    staffSettings.value[index].name = staffInfo.value[index].name || '';
    staffSettings.value[index].type = staffInfo.value[index].type || '';
    staffSettings.value[index].workStartDate = staffInfo.value[index].workStartDate || '';
    staffSettings.value[index].workEndDate = staffInfo.value[index].workEndDate || '';
  }
  
  try {
    const settings = staffSettings.value[index];
    const sisulCode = store.state.user?.m_sisul_code;
    
    if (!sisulCode) {
      alert('시설코드가 없습니다.');
      return;
    }
    
    // 시급과 근무시간을 숫자로 변환
    const timePay = typeof settings.timePay === 'number' ? settings.timePay : parseInt(String(settings.timePay).replace(/,/g, '')) || 0;
    const workHours = typeof settings.workHours === 'number' ? settings.workHours : parseFloat(String(settings.workHours)) || 0;
    
    // 기본급 계산
    const basicPay = Math.floor(timePay * workHours);
    
    // 수당 변환
    const parseAllowance = (value: any) => {
      if (!value) return 0;
      return typeof value === 'number' ? value : parseInt(String(value).replace(/,/g, '')) || 0;
    };
    
    const overtimeAllowance = parseAllowance(settings.overtimeAllowance);
    const nightAllowance = parseAllowance(settings.nightAllowance);
    const holidayAllowance = parseAllowance(settings.holidayAllowance);
    const annualLeaveAllowance = parseAllowance(settings.annualLeaveAllowance);
    const longServiceAllowance = parseAllowance(settings.longServiceAllowance);
    const transportationFee = parseAllowance(settings.transportationFee);
    const educationFee = parseAllowance(settings.educationFee);
    const bonus = parseAllowance(settings.bonus);
    const otherAllowance = parseAllowance(settings.otherAllowance);
    const mealAllowance = parseAllowance(settings.mealAllowance);
    const vehicleAllowance = parseAllowance(settings.vehicleAllowance);
    const childEducationFee = parseAllowance(settings.childEducationFee);
    const welfarePay = parseAllowance(settings.welfarePay);
    
    // 총 급여 계산
    const totalPay = basicPay + overtimeAllowance + nightAllowance + holidayAllowance + annualLeaveAllowance +
                     longServiceAllowance + transportationFee + educationFee + bonus + otherAllowance +
                     mealAllowance + vehicleAllowance + childEducationFee + welfarePay;
    
    // DB 저장용 데이터 구성
    const workData = {
      emp_code: item.empCode,
      m_sisul_code: sisulCode,
      ewi_ym: searchParams.value.lebYm,
      ewi_suga_hours: workHours,
      ewi_service_days: 0, // 사복은 서비스일수가 없음
      ewi_total_minutes: Math.round(workHours * 60),
      ewi_lunch_time_count: 0,
      ewi_monthly_pay: 0,
      ewi_basic_pay: basicPay,
      ewi_weekly_pay: 0, // 사복은 주휴수당 없음
      ewi_annual_pay: annualLeaveAllowance,
      ewi_holiday_pay: holidayAllowance,
      ewi_overtime_pay: overtimeAllowance,
      ewi_night_pay: nightAllowance,
      ewi_labor_day_pay: 0,
      ewi_long_service_pay: longServiceAllowance,
      ewi_severe_care_addition: 0,
      ewi_meal_pay: mealAllowance,
      ewi_other_pay: otherAllowance,
      ewi_transportation_fee: transportationFee,
      ewi_education_fee: educationFee,
      ewi_bonus: bonus,
      ewi_vehicle_allowance: vehicleAllowance,
      ewi_child_education_fee: childEducationFee,
      ewi_welfare_pay: welfarePay,
      ewi_welfare_pay_support_deduct: settings.welfarePaySupportDeduct ? 'Y' : 'N',
      ewi_total_pay: totalPay,
      ewi_emp_yeon: settings.insurance?.nationalPension?.amount || 0,
      ewi_emp_gun: settings.insurance?.healthInsurance?.amount || 0,
      ewi_emp_jang: settings.insurance?.longTermCare?.amount || 0,
      ewi_emp_go: settings.insurance?.employmentInsurance?.amount || 0,
      ewi_emp_so: settings.tax?.incomeTax || 0,
      ewi_emp_ji: settings.tax?.localTax || 0,
      ewi_emp_support_deduction: getSupportDeductionValue(index),
      ewi_support_deduction_auto: settings.supportDeductionAuto ? 'Y' : 'N',
      ewi_emp_etc: settings.insurance?.empEtc?.amount || 0,
      ewi_emp_total_deduction: calculateEmployeeDeduction(index),
      ewi_center_yeon: settings.insurance?.nationalPension?.amount || 0,
      ewi_center_gun: settings.insurance?.healthInsurance?.amount || 0,
      ewi_center_jang: settings.insurance?.longTermCare?.amount || 0,
      ewi_center_go: settings.insurance?.employmentInsurance?.amount || 0,
      ewi_center_sil: settings.insurance?.unemployment?.amount || 0,
      ewi_center_san: settings.insurance?.industrialAccident?.amount || 0,
      ewi_center_out: settings.insurance?.retirement?.amount || 0,
      ewi_center_total_deduction: calculateCenterDeduction(index),
      ewi_net_pay: settings.totals?.netPay || 0,
      ewi_taxable_amount: settings.totals?.taxableAmount || 0,
      ewi_non_taxable_amount: settings.totals?.nonTaxableAmount || 0,
      ewi_emp_tax_savings: settings.totals?.employeeTaxSavings || 0,
      ewi_center_tax_savings: settings.totals?.centerTaxSavings || 0,
      ewi_center_profit: 0  // 사복직원은 수가금액이 없으므로 0
    };
    
    // API 호출
    const response = await axios.post('/api/calc/work-info', workData);
    
    if (response.data.success) {
      // 테이블 데이터 업데이트
      staffData.value[index].timePay = timePay;
      staffData.value[index].workHours = workHours;
      staffData.value[index].salary = basicPay;
      staffData.value[index].totalSalary = totalPay;
      staffData.value[index].allowance = overtimeAllowance + nightAllowance + holidayAllowance + 
        annualLeaveAllowance + longServiceAllowance + mealAllowance + 
        transportationFee + educationFee + bonus + otherAllowance + vehicleAllowance + childEducationFee + welfarePay;
      
      alert('급여 설정이 저장되었습니다.');
    } else {
      alert(response.data.message || '저장에 실패했습니다.');
    }
  } catch (error: any) {
    console.error('급여 설정 저장 오류:', error);
    alert(error.response?.data?.message || '저장 중 오류가 발생했습니다.');
  }
};

// 행 펼치기/접기 함수
const toggleRow = async (index: number) => {
  if (expandedRows.value.has(index)) {
    expandedRows.value.delete(index);
  } else {
    expandedRows.value.add(index);
    // 탭 초기화
    if (!activeTab.value[index]) {
      activeTab.value[index] = 'settings';
    }
    // 정보 데이터 먼저 초기화 (나이 계산 필요)
    initializeStaffInfo(index);
    // 설정 데이터 초기화 (정보의 나이를 참조) - async 함수이므로 await
    await initializeStaffSettings(index);
    // 세금 계산
    nextTick(() => {
      calculateTaxes(index);
    });
  }
};

// 사원 등록 모달 상태
const employeeFormDialog = ref(false);

// 새 사원 등록
const addNewStaff = () => {
  employeeFormDialog.value = true;
};

// 사원 등록 완료 후 콜백
const handleEmployeeSaved = async () => {
  await fetchStaffData();
  showSnackbar('사원 정보가 저장되었습니다. 새로고침하여 목록을 확인하세요.', 'success');
};

// 새로 추가된 행인지 확인하는 함수 (애니메이션용)
const isNewRow = (index: number) => {
  return newRows.value.has(index);
};

// 새로 등록된 행인지 확인하는 함수 (삭제 가능 여부 판단)
const isNewlyAddedRow = (index: number) => {
  const item = staffData.value[index];
  // empCode가 없거나 비어있으면 새로 등록된 행
  return !item?.empCode || item.empCode === '';
};

// 행 삭제 함수
const deleteStaffRow = (index: number) => {
  if (!isNewlyAddedRow(index)) {
    alert('기존 직원 데이터는 삭제할 수 없습니다.');
    return;
  }
  
  if (!confirm('정말로 이 행을 삭제하시겠습니까?')) {
    return;
  }
  
  // 행 삭제
  staffData.value.splice(index, 1);
  
  // 관련 데이터 정리
  expandedRows.value.delete(index);
  newRows.value.delete(index);
  delete activeTab.value[index];
  delete staffSettings.value[index];
  delete staffInfo.value[index];
  
  // 인덱스 재조정 (삭제된 행 이후의 인덱스들을 조정)
  const keysToUpdate = Object.keys(expandedRows.value).map(Number).filter(i => i > index);
  keysToUpdate.forEach(oldIndex => {
    const newIndex = oldIndex - 1;
    if (expandedRows.value.has(oldIndex)) {
      expandedRows.value.delete(oldIndex);
      expandedRows.value.add(newIndex);
    }
    if (newRows.value.has(oldIndex)) {
      newRows.value.delete(oldIndex);
      newRows.value.add(newIndex);
    }
    if (activeTab.value[oldIndex]) {
      activeTab.value[newIndex] = activeTab.value[oldIndex];
      delete activeTab.value[oldIndex];
    }
    if (staffSettings.value[oldIndex]) {
      staffSettings.value[newIndex] = staffSettings.value[oldIndex];
      delete staffSettings.value[oldIndex];
    }
    if (staffInfo.value[oldIndex]) {
      staffInfo.value[newIndex] = staffInfo.value[oldIndex];
      delete staffInfo.value[oldIndex];
    }
  });
};

// 현재 년월이 1월인지 확인
const isFirstMonth = computed(() => {
  const currentYm = searchParams.value.lebYm;
  if (!currentYm || currentYm.length !== 6) return true;
  const month = parseInt(currentYm.substring(4, 6));
  return month === 1;
});

// 처우개선비 표시 가능 여부 (2026년 이후)
const isWelfarePayAvailable = computed(() => {
  const currentYm = searchParams.value.lebYm;
  if (!currentYm || currentYm.length !== 6) return false;
  return currentYm >= '202601';
});

// 저장 가능한 직원 데이터가 있는지 확인
const hasStaffData = computed(() => {
  return staffData.value.some((staff: any) => staff.empCode && staff.empCode !== '');
});

// 이전 달 데이터 가져오기
const copyPreviousMonthData = async () => {
  const currentYm = searchParams.value.lebYm;
  if (!currentYm || currentYm.length !== 6) {
    alert('올바른 년월을 선택해주세요.');
    return;
  }
  
  const currentMonth = parseInt(currentYm.substring(4, 6));
  
  // 1월인 경우 불가능
  if (currentMonth === 1) {
    alert('1월에는 과거 데이터를 가져올 수 없습니다.');
    return;
  }
  
  // 이전 달 계산
  const currentYear = parseInt(currentYm.substring(0, 4));
  const previousMonth = currentMonth - 1;
  const previousYm = `${currentYear}${String(previousMonth).padStart(2, '0')}`;
  
  if (!confirm(`${previousYm}월의 데이터를 ${currentYm}월로 복사하시겠습니까?`)) {
    return;
  }
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    if (!sisulCode) {
      alert('시설코드가 없습니다.');
      return;
    }
    
    const response = await axios.post('/api/calc/work-info/copy-previous', {
      sisulCode: sisulCode,
      currentYm: currentYm
    });
    
    if (response.data.success) {
      alert(response.data.message || '과거 데이터가 성공적으로 복사되었습니다.');
      // 데이터 다시 조회
      await fetchStaffData();
    } else {
      alert(response.data.message || '과거 데이터 복사에 실패했습니다.');
    }
  } catch (error: any) {
    console.error('과거 데이터 복사 오류:', error);
    alert(error.response?.data?.message || '과거 데이터 복사 중 오류가 발생했습니다.');
  }
};

// 모든 직원 저장
const saveAllStaff = async () => {
  if (saving.value) return;

  const sisulCode = store.state.user?.m_sisul_code;
  if (!sisulCode || !searchParams.value.lebYm) {
    showSnackbar('시설코드와 년월을 확인해주세요.', 'error');
    return;
  }

  if (staffData.value.length === 0) {
    showSnackbar('저장할 직원 데이터가 없습니다.', 'error');
    return;
  }

  // empCode가 있는 직원만 필터링
  const staffWithEmpCode = staffData.value.filter((staff: any) => staff.empCode && staff.empCode !== '');

  if (staffWithEmpCode.length === 0) {
    showSnackbar('저장 가능한 직원이 없습니다. 먼저 사원 정보를 저장해주세요.', 'error');
    return;
  }

  saving.value = true;
  let successCount = 0;
  let failCount = 0;
  const totalCount = staffData.value.length;

  try {
    // 각 직원에 대해 저장 로직 실행
    for (let i = 0; i < staffData.value.length; i++) {
      const staff = staffData.value[i];
      
      // empCode가 없는 직원은 건너뛰기
      if (!staff.empCode || staff.empCode === '') {
        continue;
      }

      // staffSettings가 초기화되지 않은 경우 초기화
      if (!staffSettings.value[i]) {
        await initializeStaffSettings(i);
        await nextTick();
        calculateTaxes(i);
      }

      try {
        const settings = staffSettings.value[i];
        
        // 시급과 근무시간을 숫자로 변환
        const timePay = typeof settings.timePay === 'number' ? settings.timePay : parseInt(String(settings.timePay).replace(/,/g, '')) || 0;
        const workHours = typeof settings.workHours === 'number' ? settings.workHours : parseFloat(String(settings.workHours)) || 0;
        
        // 기본급 계산
        const basicPay = Math.floor(timePay * workHours);
        
        // 수당 변환
        const parseAllowance = (value: any) => {
          if (!value) return 0;
          return typeof value === 'number' ? value : parseInt(String(value).replace(/,/g, '')) || 0;
        };
        
        const overtimeAllowance = parseAllowance(settings.overtimeAllowance);
        const nightAllowance = parseAllowance(settings.nightAllowance);
        const holidayAllowance = parseAllowance(settings.holidayAllowance);
        const annualLeaveAllowance = parseAllowance(settings.annualLeaveAllowance);
        const longServiceAllowance = parseAllowance(settings.longServiceAllowance);
        const transportationFee = parseAllowance(settings.transportationFee);
        const educationFee = parseAllowance(settings.educationFee);
        const bonus = parseAllowance(settings.bonus);
        const otherAllowance = parseAllowance(settings.otherAllowance);
        const mealAllowance = parseAllowance(settings.mealAllowance);
        const vehicleAllowance = parseAllowance(settings.vehicleAllowance);
        const childEducationFee = parseAllowance(settings.childEducationFee);
        const welfarePay = parseAllowance(settings.welfarePay);
        
        // 디버그 로그
        console.log(`[DEBUG] saveAllStaff - ${staff.name}:`, {
          'settings.welfarePay': settings.welfarePay,
          'parsed welfarePay': welfarePay,
          'staffSettings[i]': staffSettings.value[i] ? 'exists' : 'null'
        });
        
        // 총 급여 계산
        const totalPay = basicPay + overtimeAllowance + nightAllowance + holidayAllowance + annualLeaveAllowance +
                         longServiceAllowance + transportationFee + educationFee + bonus + otherAllowance +
                         mealAllowance + vehicleAllowance + childEducationFee + welfarePay;
        
        // DB 저장용 데이터 구성
        const workData = {
          emp_code: staff.empCode,
          m_sisul_code: sisulCode,
          ewi_ym: searchParams.value.lebYm,
          ewi_suga_hours: workHours,
          ewi_service_days: 0,
          ewi_total_minutes: Math.round(workHours * 60),
          ewi_lunch_time_count: 0,
          ewi_monthly_pay: 0,
          ewi_basic_pay: basicPay,
          ewi_weekly_pay: 0,
          ewi_annual_pay: annualLeaveAllowance,
          ewi_holiday_pay: holidayAllowance,
          ewi_overtime_pay: overtimeAllowance,
          ewi_night_pay: nightAllowance,
          ewi_labor_day_pay: 0,
          ewi_long_service_pay: longServiceAllowance,
          ewi_severe_care_addition: 0,
          ewi_meal_pay: mealAllowance,
          ewi_other_pay: otherAllowance,
          ewi_transportation_fee: transportationFee,
          ewi_education_fee: educationFee,
          ewi_bonus: bonus,
          ewi_vehicle_allowance: vehicleAllowance,
          ewi_child_education_fee: childEducationFee,
          ewi_welfare_pay: welfarePay,
          ewi_welfare_pay_support_deduct: settings.welfarePaySupportDeduct ? 'Y' : 'N',
          ewi_total_pay: totalPay,
          ewi_emp_yeon: settings.insurance?.nationalPension?.amount || 0,
          ewi_emp_gun: settings.insurance?.healthInsurance?.amount || 0,
          ewi_emp_jang: settings.insurance?.longTermCare?.amount || 0,
          ewi_emp_go: settings.insurance?.employmentInsurance?.amount || 0,
          ewi_emp_so: settings.tax?.incomeTax || 0,
          ewi_emp_ji: settings.tax?.localTax || 0,
          ewi_emp_support_deduction: getSupportDeductionValue(i),
          ewi_support_deduction_auto: settings.supportDeductionAuto ? 'Y' : 'N',
          ewi_emp_etc: settings.insurance?.empEtc?.amount || 0,
          ewi_emp_total_deduction: calculateEmployeeDeduction(i),
          ewi_center_yeon: settings.insurance?.nationalPension?.amount || 0,
          ewi_center_gun: settings.insurance?.healthInsurance?.amount || 0,
          ewi_center_jang: settings.insurance?.longTermCare?.amount || 0,
          ewi_center_go: settings.insurance?.employmentInsurance?.amount || 0,
          ewi_center_sil: settings.insurance?.unemployment?.amount || 0,
          ewi_center_san: settings.insurance?.industrialAccident?.amount || 0,
          ewi_center_out: settings.insurance?.retirement?.amount || 0,
          ewi_center_total_deduction: calculateCenterDeduction(i),
          ewi_net_pay: settings.totals?.netPay || 0,
          ewi_taxable_amount: settings.totals?.taxableAmount || 0,
          ewi_non_taxable_amount: settings.totals?.nonTaxableAmount || 0,
          ewi_emp_tax_savings: settings.totals?.employeeTaxSavings || 0,
          ewi_center_tax_savings: settings.totals?.centerTaxSavings || 0,
          ewi_center_profit: 0  // 사복직원은 수가금액이 없으므로 0
        };

        // API 호출
        const response = await axios.post('/api/calc/work-info', workData);
        
        if (response.data.success) {
          // 테이블 데이터 즉시 업데이트
          staffData.value[i].timePay = timePay;
          staffData.value[i].workHours = workHours;
          staffData.value[i].salary = basicPay;
          staffData.value[i].totalSalary = totalPay;
          staffData.value[i].allowance = overtimeAllowance + nightAllowance + holidayAllowance + 
            annualLeaveAllowance + longServiceAllowance + mealAllowance + 
            transportationFee + educationFee + bonus + otherAllowance + vehicleAllowance + childEducationFee + welfarePay;
          
          successCount++;
        } else {
          failCount++;
          console.error(`${staff.name} 저장 실패:`, response.data.message);
        }
      } catch (error: any) {
        failCount++;
        console.error(`${staff.name} 저장 오류:`, error);
      }
    }

    // 결과 메시지 표시
    if (successCount > 0) {
      showSnackbar(`시급 및 설정 정보 ${successCount}건이 성공적으로 저장되었습니다. (전체 ${totalCount}개 중)`, 'success');
    } else {
      showSnackbar('저장에 실패했습니다.', 'error');
    }
  } catch (error: any) {
    console.error('모든 직원 저장 오류:', error);
    showSnackbar('저장 중 오류가 발생했습니다.', 'error');
  } finally {
    saving.value = false;
  }
};

// 외부에서 접근 가능하도록 expose (computed로 변환하여 반응성 유지)
__expose({
  get staffData() {
    return staffData.value;
  },
  get staffSettings() {
    return staffSettings.value;
  },
  get searchParams() {
    return searchParams.value;
  },
  // 추가: 데이터 업데이트 트리거 함수
  triggerUpdate: () => {
    // 부모 컴포넌트에서 이 함수를 호출하면 computed가 재평가됨
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "control-item" }, null, -1)),
          _createVNode(_component_v_spacer),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_btn, {
              color: "gray-darken-1",
              variant: "elevated",
              class: "save-btn",
              onClick: addNewStaff,
              disabled: __props.isMagam
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-plus-circle", -1)
                  ]))]),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "등록", -1))
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_v_btn, {
              color: "gray-darken-1",
              variant: "elevated",
              class: "save-btn",
              onClick: saveAllStaff,
              loading: saving.value,
              disabled: staffData.value.length === 0 || !hasStaffData.value || __props.isMagam
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-content-save", -1)
                  ]))]),
                  _: 1
                }),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "모두 저장", -1))
              ]),
              _: 1
            }, 8, ["loading", "disabled"]),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "elevated",
              class: "save-btn",
              onClick: _withModifiers(copyPreviousMonthData, ["stop"]),
              disabled: isFirstMonth.value || __props.isMagam
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("mdi-history", -1)
                  ]))]),
                  _: 1
                }),
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "과거 데이터 가져오기", -1))
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    (staffData.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[115] || (_cache[115] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "성명"),
                _createElementVNode("th", null, "구분"),
                _createElementVNode("th", null, "시급"),
                _createElementVNode("th", null, "근무시간"),
                _createElementVNode("th", null, "급여"),
                _createElementVNode("th", null, "수당"),
                _createElementVNode("th", null, "총 급여")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(staffData.value, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("tr", {
                    class: _normalizeClass(["main-row clickable-row", { 
              'expanded': isRowExpanded(index),
              'new-row-blink': isNewRow(index)
            }]),
                    onClick: ($event: any) => (toggleRow(index))
                  }, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(item.name || "-"), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(item.type || "-"), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(formatMoney(item.timePay)) + "원", 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(item.workHours || 0) + "시간", 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(formatMoney(item.salary)) + "원", 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(formatMoney(item.allowance)) + "원", 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(formatMoney(item.totalSalary)) + "원", 1)
                  ], 10, _hoisted_7),
                  (isRowExpanded(index))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_v_tabs, {
                              modelValue: activeTab.value[index],
                              "onUpdate:modelValue": ($event: any) => ((activeTab.value[index]) = $event),
                              class: "mb-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_tab, { value: "settings" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      size: "18",
                                      class: "mr-1"
                                    }, {
                                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                        _createTextVNode("mdi-cog", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[13] || (_cache[13] = _createTextVNode(" 급여 설정 ", -1))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_tab, { value: "info" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      size: "18",
                                      class: "mr-1"
                                    }, {
                                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createTextVNode("mdi-information-outline", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[15] || (_cache[15] = _createTextVNode(" 사원 정보 ", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createVNode(_component_v_window, {
                              modelValue: activeTab.value[index],
                              "onUpdate:modelValue": ($event: any) => ((activeTab.value[index]) = $event)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_window_item, { value: "settings" }, {
                                  default: _withCtx(() => [
                                    (staffSettings.value[index])
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                          _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                              _cache[51] || (_cache[51] = _createElementVNode("h4", { class: "settings-card-title" }, "근무/급여 정보", -1)),
                                              _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "compact-label" }, "시급", -1)),
                                                  _createElementVNode("div", _hoisted_23, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].timePay) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onTimePayFocus($event, index)),
                                                      onBlur: ($event: any) => (onTimePayBlur($event, index)),
                                                      onInput: ($event: any) => (onTimePayInput($event, index))
                                                    }, null, 40, _hoisted_24), [
                                                      [_vModelText, staffSettings.value[index].timePay]
                                                    ]),
                                                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_25, [
                                                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "compact-label" }, "근무시간", -1)),
                                                  _createElementVNode("div", _hoisted_26, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].workHours) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "5",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onWorkHoursFocus($event, index)),
                                                      onBlur: ($event: any) => (onWorkHoursBlur($event, index)),
                                                      onInput: ($event: any) => (onWorkHoursInput($event, index))
                                                    }, null, 40, _hoisted_27), [
                                                      [_vModelText, staffSettings.value[index].workHours]
                                                    ]),
                                                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "suffix-text" }, "시간", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_28, [
                                                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "compact-label" }, "급여", -1)),
                                                  _createElementVNode("div", _hoisted_29, [
                                                    _createElementVNode("input", {
                                                      value: calculateSalary(index),
                                                      type: "text",
                                                      class: "compact-input",
                                                      readonly: "",
                                                      placeholder: "0"
                                                    }, null, 8, _hoisted_30),
                                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_31, [
                                                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "compact-label" }, "연장수당", -1)),
                                                  _createElementVNode("div", _hoisted_32, [
                                                    _createElementVNode("div", _hoisted_33, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].overtimeHours) = $event),
                                                        type: "text",
                                                        class: "compact-input",
                                                        placeholder: "0",
                                                        maxlength: "5",
                                                        disabled: __props.isMagam,
                                                        onFocus: ($event: any) => (onAllowanceHoursFocus($event, index, 'overtime')),
                                                        onBlur: ($event: any) => (onAllowanceHoursBlur($event, index, 'overtime')),
                                                        onInput: ($event: any) => (onAllowanceHoursInput($event, index, 'overtime'))
                                                      }, null, 40, _hoisted_34), [
                                                        [_vModelText, staffSettings.value[index].overtimeHours]
                                                      ]),
                                                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "suffix-text" }, "시간", -1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_35, _toDisplayString(formatMoney(staffSettings.value[index].overtimeAllowance || 0)) + "원 ", 1)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_36, [
                                                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "compact-label" }, "야간수당", -1)),
                                                  _createElementVNode("div", _hoisted_37, [
                                                    _createElementVNode("div", _hoisted_38, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].nightHours) = $event),
                                                        type: "text",
                                                        class: "compact-input",
                                                        placeholder: "0",
                                                        maxlength: "5",
                                                        disabled: __props.isMagam,
                                                        onFocus: ($event: any) => (onAllowanceHoursFocus($event, index, 'night')),
                                                        onBlur: ($event: any) => (onAllowanceHoursBlur($event, index, 'night')),
                                                        onInput: ($event: any) => (onAllowanceHoursInput($event, index, 'night'))
                                                      }, null, 40, _hoisted_39), [
                                                        [_vModelText, staffSettings.value[index].nightHours]
                                                      ]),
                                                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "suffix-text" }, "시간", -1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_40, _toDisplayString(formatMoney(staffSettings.value[index].nightAllowance || 0)) + "원 ", 1)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_41, [
                                                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "compact-label" }, "휴일수당", -1)),
                                                  _createElementVNode("div", _hoisted_42, [
                                                    _createElementVNode("div", _hoisted_43, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].holidayHours) = $event),
                                                        type: "text",
                                                        class: "compact-input",
                                                        placeholder: "0",
                                                        maxlength: "5",
                                                        disabled: __props.isMagam,
                                                        onFocus: ($event: any) => (onAllowanceHoursFocus($event, index, 'holiday')),
                                                        onBlur: ($event: any) => (onAllowanceHoursBlur($event, index, 'holiday')),
                                                        onInput: ($event: any) => (onAllowanceHoursInput($event, index, 'holiday'))
                                                      }, null, 40, _hoisted_44), [
                                                        [_vModelText, staffSettings.value[index].holidayHours]
                                                      ]),
                                                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "suffix-text" }, "시간", -1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_45, _toDisplayString(formatMoney(staffSettings.value[index].holidayAllowance || 0)) + "원 ", 1)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_46, [
                                                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "compact-label" }, "연차수당", -1)),
                                                  _createElementVNode("div", _hoisted_47, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].annualLeaveAllowance) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onAllowanceFocus($event, index, 'annualLeaveAllowance')),
                                                      onBlur: ($event: any) => (onAllowanceBlur($event, index, 'annualLeaveAllowance')),
                                                      onInput: ($event: any) => (onAllowanceInput($event, index, 'annualLeaveAllowance'))
                                                    }, null, 40, _hoisted_48), [
                                                      [_vModelText, staffSettings.value[index].annualLeaveAllowance]
                                                    ]),
                                                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_49, [
                                                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "compact-label" }, "장기근속수당", -1)),
                                                  _createElementVNode("div", _hoisted_50, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].longServiceAllowance) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onAllowanceFocus($event, index, 'longServiceAllowance')),
                                                      onBlur: ($event: any) => (onAllowanceBlur($event, index, 'longServiceAllowance')),
                                                      onInput: ($event: any) => (onAllowanceInput($event, index, 'longServiceAllowance'))
                                                    }, null, 40, _hoisted_51), [
                                                      [_vModelText, staffSettings.value[index].longServiceAllowance]
                                                    ]),
                                                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_52, [
                                                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "compact-label" }, "처우개선비", -1)),
                                                  _createElementVNode("label", _hoisted_53, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "checkbox",
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].welfarePaySupportDeduct) = $event),
                                                      disabled: __props.isMagam || !staffSettings.value[index].welfarePay,
                                                      class: "welfare-support-checkbox"
                                                    }, null, 8, _hoisted_54), [
                                                      [_vModelCheckbox, staffSettings.value[index].welfarePaySupportDeduct]
                                                    ]),
                                                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "welfare-support-text mr-4 ml-2" }, "지원공제", -1))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_55, [
                                                    _createElementVNode("div", _hoisted_56, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].welfarePay) = $event),
                                                        type: "text",
                                                        class: "compact-input",
                                                        placeholder: "0",
                                                        maxlength: "9",
                                                        disabled: __props.isMagam,
                                                        onFocus: ($event: any) => (onAllowanceFocus($event, index, 'welfarePay')),
                                                        onBlur: ($event: any) => (onAllowanceBlur($event, index, 'welfarePay')),
                                                        onInput: ($event: any) => (onAllowanceInput($event, index, 'welfarePay'))
                                                      }, null, 40, _hoisted_57), [
                                                        [_vModelText, staffSettings.value[index].welfarePay]
                                                      ]),
                                                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_58, [
                                                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "compact-label" }, "교통비", -1)),
                                                  _createElementVNode("div", _hoisted_59, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].transportationFee) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onAllowanceFocus($event, index, 'transportationFee')),
                                                      onBlur: ($event: any) => (onAllowanceBlur($event, index, 'transportationFee')),
                                                      onInput: ($event: any) => (onAllowanceInput($event, index, 'transportationFee'))
                                                    }, null, 40, _hoisted_60), [
                                                      [_vModelText, staffSettings.value[index].transportationFee]
                                                    ]),
                                                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_61, [
                                                  _cache[38] || (_cache[38] = _createElementVNode("label", { class: "compact-label" }, "교육비", -1)),
                                                  _createElementVNode("div", _hoisted_62, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].educationFee) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onAllowanceFocus($event, index, 'educationFee')),
                                                      onBlur: ($event: any) => (onAllowanceBlur($event, index, 'educationFee')),
                                                      onInput: ($event: any) => (onAllowanceInput($event, index, 'educationFee'))
                                                    }, null, 40, _hoisted_63), [
                                                      [_vModelText, staffSettings.value[index].educationFee]
                                                    ]),
                                                    _cache[37] || (_cache[37] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_64, [
                                                  _cache[40] || (_cache[40] = _createElementVNode("label", { class: "compact-label" }, "상여금", -1)),
                                                  _createElementVNode("div", _hoisted_65, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].bonus) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onAllowanceFocus($event, index, 'bonus')),
                                                      onBlur: ($event: any) => (onAllowanceBlur($event, index, 'bonus')),
                                                      onInput: ($event: any) => (onAllowanceInput($event, index, 'bonus'))
                                                    }, null, 40, _hoisted_66), [
                                                      [_vModelText, staffSettings.value[index].bonus]
                                                    ]),
                                                    _cache[39] || (_cache[39] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_67, [
                                                  _cache[42] || (_cache[42] = _createElementVNode("label", { class: "compact-label" }, "기타수당", -1)),
                                                  _createElementVNode("div", _hoisted_68, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].otherAllowance) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onAllowanceFocus($event, index, 'otherAllowance')),
                                                      onBlur: ($event: any) => (onAllowanceBlur($event, index, 'otherAllowance')),
                                                      onInput: ($event: any) => (onAllowanceInput($event, index, 'otherAllowance'))
                                                    }, null, 40, _hoisted_69), [
                                                      [_vModelText, staffSettings.value[index].otherAllowance]
                                                    ]),
                                                    _cache[41] || (_cache[41] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_70, [
                                                  _cache[44] || (_cache[44] = _createElementVNode("label", { class: "compact-label" }, "중식비", -1)),
                                                  _createElementVNode("div", _hoisted_71, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].mealAllowance) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onAllowanceFocus($event, index, 'mealAllowance')),
                                                      onBlur: ($event: any) => (onAllowanceBlur($event, index, 'mealAllowance')),
                                                      onInput: ($event: any) => (onAllowanceInput($event, index, 'mealAllowance'))
                                                    }, null, 40, _hoisted_72), [
                                                      [_vModelText, staffSettings.value[index].mealAllowance]
                                                    ]),
                                                    _cache[43] || (_cache[43] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_73, [
                                                  _cache[46] || (_cache[46] = _createElementVNode("label", { class: "compact-label" }, "차량보조비", -1)),
                                                  _createElementVNode("div", _hoisted_74, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].vehicleAllowance) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onAllowanceFocus($event, index, 'vehicleAllowance')),
                                                      onBlur: ($event: any) => (onAllowanceBlur($event, index, 'vehicleAllowance')),
                                                      onInput: ($event: any) => (onAllowanceInput($event, index, 'vehicleAllowance'))
                                                    }, null, 40, _hoisted_75), [
                                                      [_vModelText, staffSettings.value[index].vehicleAllowance]
                                                    ]),
                                                    _cache[45] || (_cache[45] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_76, [
                                                  _cache[48] || (_cache[48] = _createElementVNode("label", { class: "compact-label" }, "자녀교육비", -1)),
                                                  _createElementVNode("div", _hoisted_77, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].childEducationFee) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "0",
                                                      maxlength: "9",
                                                      disabled: __props.isMagam,
                                                      onFocus: ($event: any) => (onAllowanceFocus($event, index, 'childEducationFee')),
                                                      onBlur: ($event: any) => (onAllowanceBlur($event, index, 'childEducationFee')),
                                                      onInput: ($event: any) => (onAllowanceInput($event, index, 'childEducationFee'))
                                                    }, null, 40, _hoisted_78), [
                                                      [_vModelText, staffSettings.value[index].childEducationFee]
                                                    ]),
                                                    _cache[47] || (_cache[47] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_79, [
                                                  _cache[50] || (_cache[50] = _createElementVNode("label", { class: "compact-label" }, "총 급여", -1)),
                                                  _createElementVNode("div", _hoisted_80, [
                                                    _createElementVNode("input", {
                                                      value: calculateTotalSalary(index),
                                                      type: "text",
                                                      class: "compact-input",
                                                      readonly: "",
                                                      placeholder: "0"
                                                    }, null, 8, _hoisted_81),
                                                    _cache[49] || (_cache[49] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_82, [
                                              _cache[91] || (_cache[91] = _createElementVNode("h4", { class: "settings-card-title" }, "공제 정보", -1)),
                                              _createElementVNode("div", _hoisted_83, [
                                                _createElementVNode("div", _hoisted_84, [
                                                  _createElementVNode("h5", _hoisted_85, [
                                                    _cache[52] || (_cache[52] = _createTextVNode("근로자 공제 ", -1)),
                                                    _createElementVNode("span", _hoisted_86, "(만 " + _toDisplayString(staffSettings.value[index]?.age) + "세)", 1)
                                                  ]),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokDeductionTooltip(index, 'nationalPension')
                                                  }, [
                                                    _createElementVNode("label", _hoisted_88, [
                                                      _cache[53] || (_cache[53] = _createTextVNode(" 국민연금 ", -1)),
                                                      _createElementVNode("div", _hoisted_89, [
                                                        _createVNode(_component_v_checkbox, {
                                                          class: "deduction-toggle-checkbox",
                                                          "hide-details": "",
                                                          density: "compact",
                                                          color: "primary",
                                                          "model-value": staffSettings.value[index]?.insurance?.nationalPension?.deduct,
                                                          disabled: __props.isMagam,
                                                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                                                          "onUpdate:modelValue": ($event: any) => (setNationalPensionDeduction(index, Boolean($event)))
                                                        }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"])
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_90, [
                                                      (staffSettings.value[index]?.insurance?.nationalPension?.deduct)
                                                        ? (_openBlock(), _createElementBlock("input", {
                                                            key: 0,
                                                            value: nationalPensionDisplay.value[index],
                                                            type: "text",
                                                            class: "compact-input",
                                                            placeholder: "0",
                                                            maxlength: "11",
                                                            disabled: __props.isMagam,
                                                            onFocus: ($event: any) => (onNationalPensionFocus($event, index)),
                                                            onBlur: ($event: any) => (onNationalPensionBlur($event, index)),
                                                            onInput: ($event: any) => (onNationalPensionInput($event, index))
                                                          }, null, 40, _hoisted_91))
                                                        : (_openBlock(), _createElementBlock("input", _hoisted_92)),
                                                      _cache[54] || (_cache[54] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_87),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokDeductionTooltip(index, 'healthInsurance')
                                                  }, [
                                                    _cache[56] || (_cache[56] = _createElementVNode("label", { class: "compact-label" }, "건강보험", -1)),
                                                    _createElementVNode("div", _hoisted_94, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.insurance?.healthInsurance?.amount || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_95),
                                                      _cache[55] || (_cache[55] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_93),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokDeductionTooltip(index, 'longTermCare')
                                                  }, [
                                                    _cache[58] || (_cache[58] = _createElementVNode("label", { class: "compact-label" }, "장기요양보험", -1)),
                                                    _createElementVNode("div", _hoisted_97, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.insurance?.longTermCare?.amount || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_98),
                                                      _cache[57] || (_cache[57] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_96),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokDeductionTooltip(index, 'employmentInsurance')
                                                  }, [
                                                    _createElementVNode("label", _hoisted_100, [
                                                      _cache[59] || (_cache[59] = _createTextVNode(" 고용보험 ", -1)),
                                                      _createElementVNode("div", _hoisted_101, [
                                                        _createVNode(_component_v_checkbox, {
                                                          class: "deduction-toggle-checkbox",
                                                          "hide-details": "",
                                                          density: "compact",
                                                          color: "primary",
                                                          "model-value": staffSettings.value[index]?.insurance?.employmentInsurance?.deduct,
                                                          disabled: __props.isMagam,
                                                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                                                          "onUpdate:modelValue": ($event: any) => (setEmploymentInsuranceDeduction(index, Boolean($event)))
                                                        }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"])
                                                      ]),
                                                      (staffSettings.value[index]?.age >= 65)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_102, "(만 " + _toDisplayString(staffSettings.value[index]?.age) + "세)", 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_103, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.insurance?.employmentInsurance?.amount || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_104),
                                                      _cache[60] || (_cache[60] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_99),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokDeductionTooltip(index, 'incomeTax')
                                                  }, [
                                                    _cache[62] || (_cache[62] = _createElementVNode("label", { class: "compact-label" }, "소득세", -1)),
                                                    _createElementVNode("div", _hoisted_106, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.tax?.incomeTax || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_107),
                                                      _cache[61] || (_cache[61] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_105),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokDeductionTooltip(index, 'localTax')
                                                  }, [
                                                    _cache[64] || (_cache[64] = _createElementVNode("label", { class: "compact-label" }, "지방세", -1)),
                                                    _createElementVNode("div", _hoisted_109, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.tax?.localTax || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_110),
                                                      _cache[63] || (_cache[63] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_108),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokDeductionTooltip(index, 'supportDeduction')
                                                  }, [
                                                    _createElementVNode("label", _hoisted_112, [
                                                      _cache[66] || (_cache[66] = _createTextVNode(" 지원공제 ", -1)),
                                                      _createVNode(_component_v_tooltip, { location: "top" }, {
                                                        activator: _withCtx(({ props }) => [
                                                          _withDirectives(_createElementVNode("input", _mergeProps({
                                                            type: "checkbox",
                                                            "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].supportDeductionAuto) = $event),
                                                            onChange: ($event: any) => (onSupportDeductionAutoToggle(index)),
                                                            disabled: __props.isMagam,
                                                            class: "support-deduction-checkbox ml-2"
                                                          }, { ref_for: true }, props), null, 16, _hoisted_113), [
                                                            [_vModelCheckbox, staffSettings.value[index].supportDeductionAuto]
                                                          ])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _cache[65] || (_cache[65] = _createElementVNode("span", null, "체크 시 자동 계산, 해제 시 직접 입력", -1))
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_114, [
                                                      (staffSettings.value[index]?.supportDeductionAuto)
                                                        ? (_openBlock(), _createElementBlock("input", {
                                                            key: 0,
                                                            value: formatMoney(supportDeductionDisplay.value[index] || 0),
                                                            type: "text",
                                                            class: "compact-input",
                                                            readonly: "",
                                                            placeholder: "0"
                                                          }, null, 8, _hoisted_115))
                                                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                            key: 1,
                                                            "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].supportDeductionManual) = $event),
                                                            type: "text",
                                                            class: "compact-input",
                                                            disabled: __props.isMagam,
                                                            placeholder: "0",
                                                            onInput: ($event: any) => (onSupportDeductionManualInput($event, index)),
                                                            onBlur: ($event: any) => (onSupportDeductionManualBlur($event, index)),
                                                            onFocus: ($event: any) => (onSupportDeductionManualFocus($event, index))
                                                          }, null, 40, _hoisted_116)), [
                                                            [_vModelText, staffSettings.value[index].supportDeductionManual]
                                                          ]),
                                                      _cache[67] || (_cache[67] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_111),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value && staffSettings.value[index]?.insurance?.empEtc?.apply }]),
                                                    title: staffSettings.value[index]?.insurance?.empEtc?.apply ? sabokDeductionTooltip(index, 'empEtc') : ''
                                                  }, [
                                                    _createElementVNode("label", _hoisted_118, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "checkbox",
                                                        "onUpdate:modelValue": ($event: any) => ((staffSettings.value[index].insurance.empEtc.apply) = $event),
                                                        onChange: ($event: any) => (onEmpEtcToggle(index)),
                                                        disabled: __props.isMagam,
                                                        class: "deduction-checkbox"
                                                      }, null, 40, _hoisted_119), [
                                                        [_vModelCheckbox, staffSettings.value[index].insurance.empEtc.apply]
                                                      ]),
                                                      _cache[68] || (_cache[68] = _createTextVNode(" 기타공제(근로자) ", -1))
                                                    ]),
                                                    (staffSettings.value[index]?.insurance?.empEtc?.apply)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                                          _createElementVNode("input", {
                                                            value: formatEtcAmount(staffSettings.value[index]?.insurance?.empEtc?.amount || 0),
                                                            onInput: ($event: any) => (onEmpEtcInput($event, index)),
                                                            onBlur: ($event: any) => (onEmpEtcBlur($event, index)),
                                                            onFocus: ($event: any) => (onEmpEtcFocus($event, index)),
                                                            type: "text",
                                                            class: "compact-input",
                                                            disabled: __props.isMagam,
                                                            placeholder: "0"
                                                          }, null, 40, _hoisted_121),
                                                          _cache[69] || (_cache[69] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ], 10, _hoisted_117),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field total-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokDeductionTooltip(index, 'totalDeduction')
                                                  }, [
                                                    _cache[71] || (_cache[71] = _createElementVNode("label", { class: "compact-label" }, "근로자 공제 합계", -1)),
                                                    _createElementVNode("div", _hoisted_123, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(calculateEmployeeDeduction(index)),
                                                        type: "text",
                                                        class: "compact-input total-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_124),
                                                      _cache[70] || (_cache[70] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_122)
                                                ]),
                                                _createElementVNode("div", _hoisted_125, [
                                                  _createElementVNode("h5", _hoisted_126, [
                                                    _cache[72] || (_cache[72] = _createTextVNode("기관 공제 ", -1)),
                                                    _createElementVNode("span", _hoisted_127, "(만 " + _toDisplayString(staffSettings.value[index]?.age) + "세)", 1)
                                                  ]),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokCenterTooltip(index, 'nationalPension')
                                                  }, [
                                                    _cache[74] || (_cache[74] = _createElementVNode("label", { class: "compact-label" }, "국민연금", -1)),
                                                    _createElementVNode("div", _hoisted_129, [
                                                      _createElementVNode("input", {
                                                        value: nationalPensionDisplay.value[index],
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_130),
                                                      _cache[73] || (_cache[73] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_128),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokCenterTooltip(index, 'healthInsurance')
                                                  }, [
                                                    _cache[76] || (_cache[76] = _createElementVNode("label", { class: "compact-label" }, "건강보험", -1)),
                                                    _createElementVNode("div", _hoisted_132, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.insurance?.healthInsurance?.amount || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_133),
                                                      _cache[75] || (_cache[75] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_131),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokCenterTooltip(index, 'longTermCare')
                                                  }, [
                                                    _cache[78] || (_cache[78] = _createElementVNode("label", { class: "compact-label" }, "장기요양보험", -1)),
                                                    _createElementVNode("div", _hoisted_135, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.insurance?.longTermCare?.amount || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_136),
                                                      _cache[77] || (_cache[77] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_134),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokCenterTooltip(index, 'employmentInsurance')
                                                  }, [
                                                    _cache[80] || (_cache[80] = _createElementVNode("label", { class: "compact-label" }, "고용보험", -1)),
                                                    _createElementVNode("div", _hoisted_138, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.insurance?.employmentInsurance?.amount || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_139),
                                                      _cache[79] || (_cache[79] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_137),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokCenterTooltip(index, 'unemployment')
                                                  }, [
                                                    _cache[82] || (_cache[82] = _createElementVNode("label", { class: "compact-label" }, "실업급여", -1)),
                                                    _createElementVNode("div", _hoisted_141, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.insurance?.unemployment?.amount || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_142),
                                                      _cache[81] || (_cache[81] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_140),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokCenterTooltip(index, 'industrialAccident')
                                                  }, [
                                                    _cache[84] || (_cache[84] = _createElementVNode("label", { class: "compact-label" }, "산재보험", -1)),
                                                    _createElementVNode("div", _hoisted_144, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.insurance?.industrialAccident?.amount || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_145),
                                                      _cache[83] || (_cache[83] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_143),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokCenterTooltip(index, 'retirement')
                                                  }, [
                                                    _cache[86] || (_cache[86] = _createElementVNode("label", { class: "compact-label" }, "퇴직금", -1)),
                                                    _createElementVNode("div", _hoisted_147, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(staffSettings.value[index]?.insurance?.retirement?.amount || 0),
                                                        type: "text",
                                                        class: "compact-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_148),
                                                      _cache[85] || (_cache[85] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_146),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["compact-field total-field", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                    title: sabokCenterTooltip(index, 'totalCenter')
                                                  }, [
                                                    _cache[88] || (_cache[88] = _createElementVNode("label", { class: "compact-label" }, "기관 공제 합계", -1)),
                                                    _createElementVNode("div", _hoisted_150, [
                                                      _createElementVNode("input", {
                                                        value: formatMoney(calculateCenterDeduction(index)),
                                                        type: "text",
                                                        class: "compact-input total-input",
                                                        readonly: "",
                                                        placeholder: "0"
                                                      }, null, 8, _hoisted_151),
                                                      _cache[87] || (_cache[87] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                    ])
                                                  ], 10, _hoisted_149)
                                                ]),
                                                _createElementVNode("div", _hoisted_152, [
                                                  _cache[90] || (_cache[90] = _createElementVNode("label", { class: "compact-label" }, "실수령액", -1)),
                                                  _createElementVNode("div", _hoisted_153, [
                                                    _createElementVNode("input", {
                                                      value: formatMoney(staffSettings.value[index]?.totals?.netPay || 0),
                                                      type: "text",
                                                      class: "compact-input net-pay-input",
                                                      readonly: "",
                                                      placeholder: "0"
                                                    }, null, 8, _hoisted_154),
                                                    _cache[89] || (_cache[89] = _createElementVNode("span", { class: "suffix-text" }, "원", -1))
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_155, [
                                            _createVNode(_component_v_btn, {
                                              color: "primary",
                                              size: "default",
                                              variant: "elevated",
                                              class: "save-settings-btn",
                                              onClick: ($event: any) => (saveStaffAll(index)),
                                              disabled: __props.isMagam
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "18" }, {
                                                  default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                                                    _createTextVNode("mdi-content-save-all", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _cache[93] || (_cache[93] = _createElementVNode("span", { class: "ml-2" }, "저장", -1))
                                              ]),
                                              _: 1
                                            }, 8, ["onClick", "disabled"]),
                                            (isNewlyAddedRow(index))
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  color: "error",
                                                  size: "default",
                                                  variant: "elevated",
                                                  class: "delete-btn",
                                                  onClick: ($event: any) => (deleteStaffRow(index)),
                                                  disabled: __props.isMagam
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { size: "18" }, {
                                                      default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                                                        _createTextVNode("mdi-delete", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[95] || (_cache[95] = _createElementVNode("span", { class: "ml-2" }, "삭제", -1))
                                                  ]),
                                                  _: 1
                                                }, 8, ["onClick", "disabled"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_window_item, { value: "info" }, {
                                  default: _withCtx(() => [
                                    (staffInfo.value[index])
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                          _createElementVNode("div", _hoisted_157, [
                                            _createElementVNode("div", _hoisted_158, [
                                              _cache[105] || (_cache[105] = _createElementVNode("h4", { class: "settings-card-title" }, "기본 정보", -1)),
                                              _createElementVNode("div", _hoisted_159, [
                                                _createElementVNode("div", _hoisted_160, [
                                                  _cache[96] || (_cache[96] = _createElementVNode("label", { class: "compact-label" }, "사원코드", -1)),
                                                  _createElementVNode("input", {
                                                    value: staffInfo.value[index]?.staffCode || '저장 시 자동 생성',
                                                    type: "text",
                                                    class: "compact-input",
                                                    readonly: "",
                                                    placeholder: "저장 시 자동 생성"
                                                  }, null, 8, _hoisted_161)
                                                ]),
                                                _createElementVNode("div", _hoisted_162, [
                                                  _cache[97] || (_cache[97] = _createElementVNode("label", { class: "compact-label" }, "성명", -1)),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].name) = $event),
                                                    type: "text",
                                                    class: "compact-input",
                                                    placeholder: "성명",
                                                    maxlength: "20",
                                                    disabled: __props.isMagam
                                                  }, null, 8, _hoisted_163), [
                                                    [_vModelText, staffInfo.value[index].name]
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_164, [
                                                  _cache[99] || (_cache[99] = _createElementVNode("label", { class: "compact-label" }, "주민번호", -1)),
                                                  _createElementVNode("div", _hoisted_165, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].juminFront) = $event),
                                                      type: "text",
                                                      class: "compact-input jumin-front",
                                                      placeholder: "YYMMDD",
                                                      maxlength: "6",
                                                      disabled: __props.isMagam,
                                                      onInput: ($event: any) => (onJuminInputInfo(index))
                                                    }, null, 40, _hoisted_166), [
                                                      [_vModelText, staffInfo.value[index].juminFront]
                                                    ]),
                                                    _cache[98] || (_cache[98] = _createElementVNode("span", { class: "jumin-dash" }, "-", -1)),
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].juminBack) = $event),
                                                      type: "text",
                                                      class: "compact-input jumin-back",
                                                      placeholder: "G",
                                                      maxlength: "1",
                                                      disabled: __props.isMagam,
                                                      onInput: ($event: any) => (onJuminInputInfo(index))
                                                    }, null, 40, _hoisted_167), [
                                                      [_vModelText, staffInfo.value[index].juminBack]
                                                    ]),
                                                    (staffInfo.value[index]?.age)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_168, " 만 " + _toDisplayString(staffInfo.value[index].age) + "세 ", 1))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_169, [
                                                  _cache[101] || (_cache[101] = _createElementVNode("label", { class: "compact-label" }, "직종", -1)),
                                                  _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].type) = $event),
                                                    class: "compact-input compact-select",
                                                    disabled: __props.isMagam
                                                  }, [...(_cache[100] || (_cache[100] = [
                                                    _createElementVNode("option", { value: "센터장" }, "센터장", -1),
                                                    _createElementVNode("option", { value: "사회복지사" }, "사회복지사", -1)
                                                  ]))], 8, _hoisted_170), [
                                                    [_vModelSelect, staffInfo.value[index].type]
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_171, [
                                                  _cache[102] || (_cache[102] = _createElementVNode("label", { class: "compact-label" }, "입사일", -1)),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].workStartDate) = $event),
                                                    type: "date",
                                                    class: "compact-input date-compact",
                                                    disabled: __props.isMagam
                                                  }, null, 8, _hoisted_172), [
                                                    [_vModelText, staffInfo.value[index].workStartDate]
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_173, [
                                                  _cache[103] || (_cache[103] = _createElementVNode("label", { class: "compact-label" }, "퇴사일", -1)),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].workEndDate) = $event),
                                                    type: "date",
                                                    class: "compact-input date-compact",
                                                    disabled: __props.isMagam
                                                  }, null, 8, _hoisted_174), [
                                                    [_vModelText, staffInfo.value[index].workEndDate]
                                                  ])
                                                ]),
                                                (staffInfo.value[index])
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                                      _cache[104] || (_cache[104] = _createElementVNode("label", { class: "compact-label" }, "대표자", -1)),
                                                      _createElementVNode("div", _hoisted_176, [
                                                        _withDirectives(_createElementVNode("input", {
                                                          type: "checkbox",
                                                          id: `boss-checkbox-${index}`,
                                                          "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].isBoss) = $event),
                                                          disabled: __props.isMagam || isSavingBoss.value,
                                                          onChange: ($event: any) => (onBossChange(index))
                                                        }, null, 40, _hoisted_177), [
                                                          [_vModelCheckbox, staffInfo.value[index].isBoss]
                                                        ]),
                                                        _createElementVNode("label", {
                                                          for: `boss-checkbox-${index}`
                                                        }, "대표자", 8, _hoisted_178)
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_179, [
                                              _cache[110] || (_cache[110] = _createElementVNode("h4", { class: "settings-card-title" }, "연락처 정보", -1)),
                                              _createElementVNode("div", _hoisted_180, [
                                                _createElementVNode("div", _hoisted_181, [
                                                  _cache[106] || (_cache[106] = _createElementVNode("label", { class: "compact-label" }, "휴대폰번호", -1)),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].phone) = $event),
                                                    type: "text",
                                                    class: "compact-input",
                                                    placeholder: "010-1234-5678",
                                                    maxlength: "13",
                                                    disabled: __props.isMagam,
                                                    onInput: ($event: any) => (onPhoneInputInfo($event, index))
                                                  }, null, 40, _hoisted_182), [
                                                    [_vModelText, staffInfo.value[index].phone]
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_183, [
                                                  _cache[107] || (_cache[107] = _createElementVNode("label", { class: "compact-label" }, "이메일", -1)),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].email) = $event),
                                                    type: "email",
                                                    class: "compact-input",
                                                    placeholder: "이메일",
                                                    maxlength: "100",
                                                    disabled: __props.isMagam
                                                  }, null, 8, _hoisted_184), [
                                                    [_vModelText, staffInfo.value[index].email]
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_185, [
                                                  _cache[108] || (_cache[108] = _createElementVNode("label", { class: "compact-label" }, "주소", -1)),
                                                  _createElementVNode("div", _hoisted_186, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].address) = $event),
                                                      type: "text",
                                                      class: "compact-input",
                                                      placeholder: "도로명 주소",
                                                      readonly: "",
                                                      style: {"flex":"1","cursor":"pointer"},
                                                      onClick: ($event: any) => (!__props.isMagam && openAddressModal(index)),
                                                      maxlength: "150",
                                                      disabled: __props.isMagam
                                                    }, null, 8, _hoisted_187), [
                                                      [_vModelText, staffInfo.value[index].address]
                                                    ]),
                                                    _createElementVNode("button", {
                                                      type: "button",
                                                      class: "address-search-btn",
                                                      onClick: ($event: any) => (openAddressModal(index)),
                                                      disabled: __props.isMagam
                                                    }, " 주소검색 ", 8, _hoisted_188)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_189, [
                                                  _cache[109] || (_cache[109] = _createElementVNode("label", { class: "compact-label" }, "상세주소", -1)),
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((staffInfo.value[index].addressDetail) = $event),
                                                    type: "text",
                                                    class: "compact-input",
                                                    placeholder: "상세주소를 입력해주세요",
                                                    maxlength: "100",
                                                    disabled: __props.isMagam
                                                  }, null, 8, _hoisted_190), [
                                                    [_vModelText, staffInfo.value[index].addressDetail]
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_191, [
                                            (isNewlyAddedRow(index))
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  color: "error",
                                                  size: "default",
                                                  variant: "elevated",
                                                  class: "delete-btn",
                                                  onClick: ($event: any) => (deleteStaffRow(index)),
                                                  disabled: __props.isMagam
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { size: "18" }, {
                                                      default: _withCtx(() => [...(_cache[111] || (_cache[111] = [
                                                        _createTextVNode("mdi-delete", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[112] || (_cache[112] = _createElementVNode("span", { class: "ml-2" }, "삭제", -1))
                                                  ]),
                                                  _: 1
                                                }, 8, ["onClick", "disabled"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_v_btn, {
                                              color: "primary",
                                              size: "default",
                                              variant: "elevated",
                                              class: "save-settings-btn",
                                              onClick: ($event: any) => (saveStaffAll(index)),
                                              disabled: __props.isMagam
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "18" }, {
                                                  default: _withCtx(() => [...(_cache[113] || (_cache[113] = [
                                                    _createTextVNode("mdi-content-save-all", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _cache[114] || (_cache[114] = _createElementVNode("span", { class: "ml-2" }, "저장", -1))
                                              ]),
                                              _: 1
                                            }, 8, ["onClick", "disabled"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_192, [
          _createVNode(_component_v_icon, {
            size: "64",
            color: "grey"
          }, {
            default: _withCtx(() => [...(_cache[116] || (_cache[116] = [
              _createTextVNode("mdi-database-off", -1)
            ]))]),
            _: 1
          }),
          _cache[117] || (_cache[117] = _createElementVNode("p", { class: "text-grey mt-2" }, "조회된 데이터가 없습니다.", -1))
        ])),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: 3000
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (snackbar.value.show = false))
        }, {
          default: _withCtx(() => [...(_cache[118] || (_cache[118] = [
            _createTextVNode("닫기", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.message) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"]),
    _createVNode(EmployeeFormModal, {
      modelValue: employeeFormDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((employeeFormDialog).value = $event)),
      onSaved: handleEmployeeSaved
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})